// apps/web/src/data/astralTemplates.ts
import type { AstralMapData } from "../types/astral";

export interface AstralTemplate {
  id: string;
  title: string;
  description: string;
  category: string;
  badge: string;
  data: AstralMapData;
}

export const ASTRAL_TEMPLATES: AstralTemplate[] = [
  {
    id: "agency_blueprint",
    title: "Blueprint Operacional da Agência",
    description: "Estrutura mestre da agência cobrindo Marketing, Comercial, Operacional, Financeiro, Tráfego e Estratégias.",
    category: "Operação & Agência",
    badge: "Mestre",
    data: {
      rootId: "root_base",
      layout: "org",
      theme: "dark",
      viewport: { zoom: 0.85, panX: 100, panY: 80 },
      nodes: {
        root_base: {
          id: "root_base",
          parentId: null,
          text: "BASE",
          color: "#ef4444",
          side: "right",
          order: 0,
          isCollapsed: false,
        },
        // 1. MARKETING
        node_mkt: {
          id: "node_mkt",
          parentId: "root_base",
          text: "MARKETING",
          color: "#388bfd",
          side: "right",
          order: 0,
          isCollapsed: false,
        },
        node_mkt_cpa: {
          id: "node_mkt_cpa",
          parentId: "node_mkt",
          text: "CPA (Custo por Aquisição)",
          side: "right",
          order: 0,
        },
        node_mkt_leads: {
          id: "node_mkt_leads",
          parentId: "node_mkt",
          text: "NUMERO DE LEADS",
          badge: "Meta Ads",
          side: "right",
          order: 1,
        },

        // 2. COMERCIAL
        node_com: {
          id: "node_com",
          parentId: "root_base",
          text: "COMERCIAL",
          color: "#2ea043",
          side: "right",
          order: 1,
          isCollapsed: false,
        },
        node_com_conversas: {
          id: "node_com_conversas",
          parentId: "node_com",
          text: "NUMERO DE CONVERSAS",
          side: "right",
          order: 0,
        },
        node_com_realizadas: {
          id: "node_com_realizadas",
          parentId: "node_com",
          text: "NUMERO DE CONSULTAS REALIZADAS",
          side: "right",
          order: 1,
        },
        node_com_fechadas: {
          id: "node_com_fechadas",
          parentId: "node_com",
          text: "NUMERO DE CONSULTAS FECHADAS",
          badge: "Fechamento",
          side: "right",
          order: 2,
          isCollapsed: false,
        },
        node_com_epic: {
          id: "node_com_epic",
          parentId: "node_com_fechadas",
          text: "OPERACIONAL EPICO",
          side: "right",
          order: 0,
        },
        node_com_epic_armas: {
          id: "node_com_epic_armas",
          parentId: "node_com_epic",
          text: "armas da persuasao",
          side: "right",
          order: 0,
        },
        node_com_epic_micro: {
          id: "node_com_epic_micro",
          parentId: "node_com_epic",
          text: "consulta com micro resultado",
          side: "right",
          order: 1,
        },
        node_com_epic_cinderela: {
          id: "node_com_epic_cinderela",
          parentId: "node_com_epic_micro",
          text: "efeito cinderela",
          side: "right",
          order: 0,
        },
        node_com_recompra: {
          id: "node_com_recompra",
          parentId: "node_com",
          text: "NUMERO DE CLIENTES QUE RECOMPRAM",
          side: "right",
          order: 3,
        },
        node_com_recontato: {
          id: "node_com_recontato",
          parentId: "node_com",
          text: "EFETIVIDADE DE RECONTATO",
          side: "right",
          order: 4,
        },

        // 3. OPERACIONAL
        node_ops: {
          id: "node_ops",
          parentId: "root_base",
          text: "OPERACIONAL",
          color: "#a371f7",
          side: "right",
          order: 2,
          isCollapsed: false,
        },
        node_ops_cap: {
          id: "node_ops_cap",
          parentId: "node_ops",
          text: "CAPACIDADE OPERACIONAL",
          side: "right",
          order: 0,
        },
        node_ops_res: {
          id: "node_ops_res",
          parentId: "node_ops",
          text: "RESULTADO",
          side: "right",
          order: 1,
        },
        node_ops_prof: {
          id: "node_ops_prof",
          parentId: "node_ops",
          text: "CAPACIDADE PROFISSIONAL",
          side: "right",
          order: 2,
        },
        node_ops_cursos: {
          id: "node_ops_cursos",
          parentId: "node_ops",
          text: "CURSOS DE APERFEICOAMENTO",
          side: "right",
          order: 3,
        },
        node_ops_horarios: {
          id: "node_ops_horarios",
          parentId: "node_ops",
          text: "HORARIOS DE FUNCIONAMENTO",
          side: "right",
          order: 4,
        },

        // 4. FINANCEIRO
        node_fin: {
          id: "node_fin",
          parentId: "root_base",
          text: "FINANCEIRO",
          color: "#d29922",
          side: "right",
          order: 3,
          isCollapsed: false,
        },
        node_fin_ticket: {
          id: "node_fin_ticket",
          parentId: "node_fin",
          text: "TICKET MEDIO",
          badge: "Foco em Aumentar",
          side: "right",
          order: 0,
        },
        node_fin_fixo: {
          id: "node_fin_fixo",
          parentId: "node_fin",
          text: "CUSTO FIXO",
          badge: "Foco em Abaixar",
          side: "right",
          order: 1,
        },
        node_fin_var: {
          id: "node_fin_var",
          parentId: "node_fin",
          text: "CUSTO VARIAVEL",
          badge: "Foco em Abaixar",
          side: "right",
          order: 2,
        },
        node_fin_receb: {
          id: "node_fin_receb",
          parentId: "node_fin",
          text: "RECEBIVEIS E ENTREGAVEIS",
          badge: "Foco em Aumentar",
          side: "right",
          order: 3,
        },
        node_fin_caixa: {
          id: "node_fin_caixa",
          parentId: "node_fin",
          text: "CAIXA E FLUXO",
          badge: "Foco em Aumentar",
          side: "right",
          order: 4,
        },

        // 5. CANAL 1 - TRAFEGO
        node_canal1: {
          id: "node_canal1",
          parentId: "root_base",
          text: "CANAL 1 • TRAFEGO",
          color: "#39c5cf",
          side: "right",
          order: 4,
          isCollapsed: false,
        },
        node_canal1_chegou: {
          id: "node_canal1_chegou",
          parentId: "node_canal1",
          text: "LEAD CHEGOU",
          side: "right",
          order: 0,
        },
        node_canal1_msgs: {
          id: "node_canal1_msgs",
          parentId: "node_canal1",
          text: "MENSAGENS & SCRIPTS",
          link: "https://uaidash.com.br",
          side: "right",
          order: 1,
        },

        // 6. ESTRATEGIAS OBRIGATORIAS
        node_est: {
          id: "node_est",
          parentId: "root_base",
          text: "ESTRATEGIAS OBRIGATORIAS",
          color: "#f85149",
          side: "right",
          order: 5,
          isCollapsed: false,
        },
        node_est_audio: {
          id: "node_est_audio",
          parentId: "node_est",
          text: "AUDIO DEPOIS DAS 18H (QUEM AGENDOU)",
          side: "right",
          order: 0,
        },
        node_est_conf: {
          id: "node_est_conf",
          parentId: "node_est",
          text: "CONFIRMAÇÃO EM 3 ETAPAS",
          side: "right",
          order: 1,
        },
        node_est_desafio: {
          id: "node_est_desafio",
          parentId: "node_est",
          text: "DESAFIO",
          side: "right",
          order: 2,
        },
        node_est_upsell: {
          id: "node_est_upsell",
          parentId: "node_est",
          text: "UPSELL",
          badge: "Método + Skincare",
          side: "right",
          order: 3,
        },
      },
    },
  },
  {
    id: "sales_funnel",
    title: "Funil de Vendas & Tráfego Pago",
    description: "Métricas encadeadas de conversão com indicadores e taxas de passagem.",
    category: "Vendas & Tráfego",
    badge: "Métricas",
    data: {
      rootId: "root_funnel",
      layout: "map",
      theme: "dark",
      viewport: { zoom: 0.95, panX: 120, panY: 100 },
      nodes: {
        root_funnel: {
          id: "root_funnel",
          parentId: null,
          text: "FUNIL DE VENDAS",
          color: "#ef4444",
          side: "right",
          order: 0,
          isCollapsed: false,
        },
        funnel_mensagens: {
          id: "funnel_mensagens",
          parentId: "root_funnel",
          text: "MENSAGENS INICIAIS",
          badge: "50",
          color: "#388bfd",
          side: "right",
          order: 0,
        },
        funnel_conversas: {
          id: "funnel_conversas",
          parentId: "funnel_mensagens",
          text: "CONVERSAS QUALIFICADAS (50% A 70%)",
          badge: "25",
          color: "#39c5cf",
          side: "right",
          order: 0,
        },
        funnel_agendamentos: {
          id: "funnel_agendamentos",
          parentId: "funnel_conversas",
          text: "AGENDAMENTOS EFETIVOS (50%)",
          badge: "12",
          color: "#2ea043",
          side: "right",
          order: 0,
        },
        funnel_comparecimentos: {
          id: "funnel_comparecimentos",
          parentId: "funnel_agendamentos",
          text: "COMPARECIMENTOS NA CLÍNICA (50%)",
          badge: "6",
          color: "#d29922",
          side: "right",
          order: 0,
        },
        funnel_vendas: {
          id: "funnel_vendas",
          parentId: "funnel_comparecimentos",
          text: "VENDAS FECHADAS (50%)",
          badge: "3",
          color: "#f85149",
          side: "right",
          order: 0,
        },
      },
    },
  },
  {
    id: "client_onboarding",
    title: "Onboarding 360 de Novo Cliente",
    description: "Jornada de implementação de novo cliente na agência em 5 etapas.",
    category: "Processos",
    badge: "Onboarding",
    data: {
      rootId: "root_onb",
      layout: "map",
      theme: "ocean",
      viewport: { zoom: 1, panX: 80, panY: 80 },
      nodes: {
        root_onb: {
          id: "root_onb",
          parentId: null,
          text: "ONBOARDING DO CLIENTE",
          color: "#0284c7",
          side: "right",
          order: 0,
        },
        onb_1: {
          id: "onb_1",
          parentId: "root_onb",
          text: "1. Briefing & Cadastro",
          badge: "Fase 1",
          side: "right",
          order: 0,
        },
        onb_1_sub: {
          id: "onb_1_sub",
          parentId: "onb_1",
          text: "Link público uaimidiaassessoria.com.br/cadastro",
          side: "right",
          order: 0,
        },
        onb_2: {
          id: "onb_2",
          parentId: "root_onb",
          text: "2. Acessos & Conexões",
          badge: "Fase 2",
          side: "right",
          order: 1,
        },
        onb_2_meta: {
          id: "onb_2_meta",
          parentId: "onb_2",
          text: "Meta Business Manager & WhatsApp Cloud API",
          side: "right",
          order: 0,
        },
        onb_3: {
          id: "onb_3",
          parentId: "root_onb",
          text: "3. Criação de Criativos & LP",
          badge: "Fase 3",
          side: "right",
          order: 2,
        },
        onb_4: {
          id: "onb_4",
          parentId: "root_onb",
          text: "4. Lançamento da Campanha",
          badge: "Fase 4",
          side: "right",
          order: 3,
        },
        onb_5: {
          id: "onb_5",
          parentId: "root_onb",
          text: "5. Otimização Semanal & Relatórios",
          badge: "Fase 5",
          side: "right",
          order: 4,
        },
      },
    },
  },
  {
    id: "annual_strategic_plan",
    title: "Planejamento Estratégico Anual (OKRs)",
    description: "Metas anuais desdobradas em trimestres (Q1 a Q4) com pilares de crescimento.",
    category: "Gestão",
    badge: "OKRs",
    data: {
      rootId: "root_okr",
      layout: "org",
      theme: "midnight",
      viewport: { zoom: 0.9, panX: 100, panY: 60 },
      nodes: {
        root_okr: {
          id: "root_okr",
          parentId: null,
          text: "OBJETIVOS DO ANO",
          color: "#8b5cf6",
          side: "right",
          order: 0,
        },
        okr_q1: {
          id: "okr_q1",
          parentId: "root_okr",
          text: "Q1 • Estruturação & Aquisição",
          color: "#388bfd",
          side: "right",
          order: 0,
        },
        okr_q2: {
          id: "okr_q2",
          parentId: "root_okr",
          text: "Q2 • Escala de Tráfego & LPs",
          color: "#2ea043",
          side: "right",
          order: 1,
        },
        okr_q3: {
          id: "okr_q3",
          parentId: "root_okr",
          text: "Q3 • Retenção & LTV dos Clientes",
          color: "#d29922",
          side: "right",
          order: 2,
        },
        okr_q4: {
          id: "okr_q4",
          parentId: "root_okr",
          text: "Q4 • Consolidação & Recorde de Faturamento",
          color: "#f85149",
          side: "right",
          order: 3,
        },
      },
    },
  },
  {
    id: "client_onboarding_360",
    title: "Onboarding 360 de Novo Cliente",
    description: "Passo a passo estruturado em lista (outline) desde o fechamento do contrato até os primeiros anúncios no ar.",
    category: "Processos",
    badge: "Lista / Outline",
    data: {
      rootId: "root_onb",
      layout: "list",
      theme: "meister",
      defaultNodeShape: "rounded",
      viewport: { zoom: 0.95, panX: 280, panY: 200 },
      nodes: {
        root_onb: {
          id: "root_onb",
          parentId: null,
          text: "ONBOARDING DO NOVO CLIENTE",
          color: "#388bfd",
          side: "right",
          order: 0,
        },
        onb_dia0: {
          id: "onb_dia0",
          parentId: "root_onb",
          text: "Dia 0 • Assinatura & Boas-Vindas",
          color: "#2ea043",
          badge: "Comercial",
          side: "right",
          order: 0,
        },
        onb_dia0_contrato: {
          id: "onb_dia0_contrato",
          parentId: "onb_dia0",
          text: "Coleta de Assinatura via Clicksign / ZapSign",
          side: "right",
          order: 0,
        },
        onb_dia0_grupo: {
          id: "onb_dia0_grupo",
          parentId: "onb_dia0",
          text: "Criação do Grupo VIP no WhatsApp com Squad",
          side: "right",
          order: 1,
        },
        onb_dia1_3: {
          id: "onb_dia1_3",
          parentId: "root_onb",
          text: "Dias 1-3 • Briefing & Acessos Técnicos",
          color: "#388bfd",
          badge: "Técnico",
          side: "right",
          order: 1,
        },
        onb_dia1_briefing: {
          id: "onb_dia1_briefing",
          parentId: "onb_dia1_3",
          text: "Envio do Formulário de Briefing (Briefing Público)",
          side: "right",
          order: 0,
        },
        onb_dia1_bm: {
          id: "onb_dia1_bm",
          parentId: "onb_dia1_3",
          text: "Concessão de Acesso ao Gerenciador de Negócios (BM)",
          side: "right",
          order: 1,
        },
        onb_dia1_pixel: {
          id: "onb_dia1_pixel",
          parentId: "onb_dia1_3",
          text: "Instalação do Pixel Meta & Meta CAPI no Uai Dash",
          side: "right",
          order: 2,
        },
        onb_dia4_7: {
          id: "onb_dia4_7",
          parentId: "root_onb",
          text: "Dias 4-7 • Planejamento & Produção Criativa",
          color: "#d29922",
          badge: "Criativo",
          side: "right",
          order: 2,
        },
        onb_dia4_pesquisa: {
          id: "onb_dia4_pesquisa",
          parentId: "onb_dia4_7",
          text: "Auditoria de Concorrentes na Biblioteca de Anúncios",
          side: "right",
          order: 0,
        },
        onb_dia4_roteiros: {
          id: "onb_dia4_roteiros",
          parentId: "onb_dia4_7",
          text: "Roteirização de Vídeos e Copys para Aprovação",
          side: "right",
          order: 1,
        },
        onb_dia4_lp: {
          id: "onb_dia4_lp",
          parentId: "onb_dia4_7",
          text: "Criação da Landing Page de Alta Conversão",
          side: "right",
          order: 2,
        },
        onb_dia8: {
          id: "onb_dia8",
          parentId: "root_onb",
          text: "Dia 8+ • Subida de Campanhas & Tração",
          color: "#8b5cf6",
          badge: "Subida",
          side: "right",
          order: 3,
        },
        onb_dia8_subida: {
          id: "onb_dia8_subida",
          parentId: "onb_dia8",
          text: "Subida dos Conjuntos de Anúncios (CBO / ABO)",
          side: "right",
          order: 0,
        },
        onb_dia8_kanban: {
          id: "onb_dia8_kanban",
          parentId: "onb_dia8",
          text: "Verificação dos Primeiros Leads no CRM Kanban",
          side: "right",
          order: 1,
        },
      },
    },
  },
  {
    id: "swot_agency_matrix",
    title: "Matriz SWOT / FOFA da Agência",
    description: "Análise estratégica em cards executivos com Forças, Oportunidades, Fraquezas e Ameaças para 2026.",
    category: "Estratégia",
    badge: "Notion Card",
    data: {
      rootId: "root_swot",
      layout: "map",
      theme: "dark",
      defaultNodeShape: "card",
      viewport: { zoom: 0.9, panX: 0, panY: 0 },
      nodes: {
        root_swot: {
          id: "root_swot",
          parentId: null,
          text: "MATRIZ SWOT • UAIMÍDIA",
          color: "#388bfd",
          side: "right",
          order: 0,
        },
        swot_f: {
          id: "swot_f",
          parentId: "root_swot",
          text: "FORÇAS (Interno +)",
          color: "#2ea043",
          side: "left",
          order: 0,
        },
        swot_f_1: {
          id: "swot_f_1",
          parentId: "swot_f",
          text: "Cockpit próprio Uai Dash com CRM integrado",
          side: "left",
          order: 0,
        },
        swot_f_2: {
          id: "swot_f_2",
          parentId: "swot_f",
          text: "Rastreamento Meta CAPI sem perda de cookies",
          side: "left",
          order: 1,
        },
        swot_o: {
          id: "swot_o",
          parentId: "root_swot",
          text: "OPORTUNIDADES (Externo +)",
          color: "#388bfd",
          side: "right",
          order: 0,
        },
        swot_o_1: {
          id: "swot_o_1",
          parentId: "swot_o",
          text: "Expansão para tráfego local em clínicas e imobiliárias",
          side: "right",
          order: 0,
        },
        swot_o_2: {
          id: "swot_o_2",
          parentId: "swot_o",
          text: "Oferta de IA para pré-qualificação no WhatsApp",
          side: "right",
          order: 1,
        },
        swot_w: {
          id: "swot_w",
          parentId: "root_swot",
          text: "FRAQUEZAS (Interno -)",
          color: "#d29922",
          side: "left",
          order: 1,
        },
        swot_w_1: {
          id: "swot_w_1",
          parentId: "swot_w",
          text: "Gargalo no tempo de edição de criativos em vídeo",
          side: "left",
          order: 0,
        },
        swot_w_2: {
          id: "swot_w_2",
          parentId: "swot_w",
          text: "Dependência de aprovação lenta de criativos pelo cliente",
          side: "left",
          order: 1,
        },
        swot_t: {
          id: "swot_t",
          parentId: "root_swot",
          text: "AMEAÇAS (Externo -)",
          color: "#f85149",
          side: "right",
          order: 1,
        },
        swot_t_1: {
          id: "swot_t_1",
          parentId: "swot_t",
          text: "Oscilações de CPM em períodos sazonais",
          side: "right",
          order: 0,
        },
        swot_t_2: {
          id: "swot_t_2",
          parentId: "swot_t",
          text: "Bloqueios pontuais de contas por políticas da Meta",
          side: "right",
          order: 1,
        },
      },
    },
  },
  {
    id: "perpetual_funnel",
    title: "Funil Perpétuo & Lançamentos",
    description: "Estrutura completa em formato cápsula (bubble) com esteira de captura, nutrição, oferta e remarketing.",
    category: "Vendas",
    badge: "Cápsula / Bubble",
    data: {
      rootId: "root_perp",
      layout: "org",
      theme: "bubbles",
      defaultNodeShape: "bubble",
      viewport: { zoom: 0.9, panX: 100, panY: 60 },
      nodes: {
        root_perp: {
          id: "root_perp",
          parentId: null,
          text: "ESTEIRA PERPÉTUA",
          color: "#ec4899",
          side: "right",
          order: 0,
        },
        perp_captura: {
          id: "perp_captura",
          parentId: "root_perp",
          text: "1. Captura de Topo",
          color: "#3b82f6",
          badge: "Frio",
          side: "right",
          order: 0,
        },
        perp_captura_isca: {
          id: "perp_captura_isca",
          parentId: "perp_captura",
          text: "Isca Digital (Ebook / Calculadora)",
          side: "right",
          order: 0,
        },
        perp_nutricao: {
          id: "perp_nutricao",
          parentId: "root_perp",
          text: "2. Nutrição de Meio",
          color: "#10b981",
          badge: "Morno",
          side: "right",
          order: 1,
        },
        perp_nutricao_vsl: {
          id: "perp_nutricao_vsl",
          parentId: "perp_nutricao",
          text: "Vídeo de Apresentação (VSL)",
          side: "right",
          order: 0,
        },
        perp_conversao: {
          id: "perp_conversao",
          parentId: "root_perp",
          text: "3. Conversão de Fundo",
          color: "#f59e0b",
          badge: "Quente",
          side: "right",
          order: 2,
        },
        perp_conversao_checkout: {
          id: "perp_conversao_checkout",
          parentId: "perp_conversao",
          text: "Página de Pagamento com Order Bump",
          side: "right",
          order: 0,
        },
        perp_remarketing: {
          id: "perp_remarketing",
          parentId: "root_perp",
          text: "4. Remarketing Dinâmico",
          color: "#ef4444",
          badge: "Recuperação",
          side: "right",
          order: 3,
        },
        perp_remarketing_abandono: {
          id: "perp_remarketing_abandono",
          parentId: "perp_remarketing",
          text: "Anúncios para Abandono de Checkout (3 a 7 dias)",
          side: "right",
          order: 0,
        },
      },
    },
  },

  {
    id: "military_infoproduct_blueprint",
    title: "MÁQUINA MILITAR • SOBRAL & ALFACON (3 NÍVEIS)",
    description: "Estrutura completa e exaustiva em 3 Níveis: 1) Caixa Rápido para Reinvestir (com Tráfego Direto para LP - Idade Limite), 2) Lançamentos de Turmas (Semente, Clássico, Meteórico) e 3) Perpétuo 24/7 (VSL, Mentoria, Remarketing em Cascata), com diretrizes táticas completas do Pedro Sobral e Evandro Guedes.",
    category: "Infoprodutos & Tráfego",
    badge: "Master 3 Níveis",
    data: {
      "rootId": "root_militar_master",
      "layout": "map",
      "theme": "dark",
      "defaultNodeShape": "rounded",
      "viewport": {
            "zoom": 0.82,
            "panX": 0,
            "panY": 0
      },
      "nodes": {
            "root_militar_master": {
                  "id": "root_militar_master",
                  "parentId": null,
                  "text": "MÁQUINA MILITAR • SOBRAL & ALFACON",
                  "color": "#ef4444",
                  "badge": "ESTRATÉGIA SUPREMA",
                  "shape": "card",
                  "side": "right",
                  "order": 0,
                  "isCollapsed": false,
                  "note": "Ecossistema tático completo e exaustivo de Tráfego Pago, Lançamentos e Perpétuo para o nicho militar e policial, integrando a formação de 43 aulas do Pedro Sobral à identidade de alto impacto de Evandro Guedes (AlfaCon), estruturado nos 3 Níveis Estratégicos sem condensar."
            },
            "ramo_n1_caixa_rapido": {
                  "id": "ramo_n1_caixa_rapido",
                  "parentId": "root_militar_master",
                  "text": "NÍVEL 1: CAIXA RÁPIDO (REINVESTIMENTO)",
                  "color": "#10b981",
                  "badge": "FLUXO DIÁRIO / CAC ZERO",
                  "shape": "card",
                  "side": "right",
                  "order": 0,
                  "isCollapsed": false,
                  "note": "Objetivo central: Gerar caixa todos os dias no piloto automático para bancar os anúncios dos lançamentos sem tirar dinheiro do bolso. Operação auto-liquidante (SLO) com CAC Zero e criação massiva de lista de compradores qualificados."
            },
            "n1_frontend_bloco": {
                  "id": "n1_frontend_bloco",
                  "parentId": "ramo_n1_caixa_rapido",
                  "text": "1. Front-End de Baixo Atrito (R$ 27 - R$ 37)",
                  "color": "#34d399",
                  "badge": "Impulso no Tráfego Frio",
                  "side": "right",
                  "order": 0,
                  "isCollapsed": false,
                  "note": "Produto de entrada de baixo custo desenhado para quebra imediata de desconfiança e compra por impulso no tráfego frio."
            },
            "n1_front_prod_nome": {
                  "id": "n1_front_prod_nome",
                  "parentId": "n1_frontend_bloco",
                  "text": "'Cronograma Tático 90 Dias ESA/PM (Faca na Caveira)'",
                  "badge": "Produto Base",
                  "side": "right",
                  "order": 0,
                  "note": "Material 100% focado no que cai na prova da ESA, EsPCEx ou PM, eliminando PDFs teóricos gigantescos."
            },
            "n1_front_edital_vert": {
                  "id": "n1_front_edital_vert",
                  "parentId": "n1_frontend_bloco",
                  "text": "Edital Verticalizado Mastigado (Sem Teoria Inútil)",
                  "side": "right",
                  "order": 1,
                  "note": "Mapeamento tópico a tópico com indicação exata de relevância estatística da banca examinadora."
            },
            "n1_front_rotina_2h": {
                  "id": "n1_front_rotina_2h",
                  "parentId": "n1_frontend_bloco",
                  "text": "Divisão Diária de 2 Horas por Noite para CLT",
                  "side": "right",
                  "order": 2,
                  "note": "Ciclo de estudos adaptado para quem trabalha 8 a 10 horas por dia e só tem o período noturno para estudar."
            },
            "n1_front_questoes_1000": {
                  "id": "n1_front_questoes_1000",
                  "parentId": "n1_frontend_bloco",
                  "text": "Banco de 1.000 Questões Comentadas da Banca",
                  "badge": "Prática Pura",
                  "side": "right",
                  "order": 3,
                  "note": "Gabarito comentado na ferida, focado na recorrência de cobrança da Vunesp, FGV e Cebraspe."
            },
            "n1_bumps_bloco": {
                  "id": "n1_bumps_bloco",
                  "parentId": "ramo_n1_caixa_rapido",
                  "text": "2. Order Bumps no Checkout (+R$ 19 a R$ 34)",
                  "color": "#059669",
                  "badge": "Aumento de Ticket Médio",
                  "side": "right",
                  "order": 1,
                  "isCollapsed": false,
                  "note": "Ofertas complementares de 1 clique inseridas diretamente no checkout da Eduzz/Kiwify/Hotmart, elevando a margem de contribuição diária."
            },
            "n1_bump_taf": {
                  "id": "n1_bump_taf",
                  "parentId": "n1_bumps_bloco",
                  "text": "Order Bump 1: 'Guia do TAF Zero ao 10' (+R$ 19,90)",
                  "badge": "Take Rate 40%",
                  "side": "right",
                  "order": 0,
                  "note": "Planilha de treino progressivo para barra fixa militar, corrida de 12 minutos e abdominais remador para não reprovar no teste físico."
            },
            "n1_bump_taf_detalhe": {
                  "id": "n1_bump_taf_detalhe",
                  "parentId": "n1_bump_taf",
                  "text": "Cronograma de 60 Dias Anti-Lesão para o Físico",
                  "side": "right",
                  "order": 0,
                  "note": "Evolução do sedentarismo ao índice máximo exigido pelas Forças Armadas e Polícias."
            },
            "n1_bump_pegadinhas": {
                  "id": "n1_bump_pegadinhas",
                  "parentId": "n1_bumps_bloco",
                  "text": "Order Bump 2: '500 Questões Mais Pegadinhas' (+R$ 14,90)",
                  "badge": "Take Rate 25%",
                  "side": "right",
                  "order": 1,
                  "note": "Mapeamento das questões mais traiçoeiras com resolução em áudios curtos de 1 minuto pelo professor."
            },
            "n1_upsell_bloco": {
                  "id": "n1_upsell_bloco",
                  "parentId": "ramo_n1_caixa_rapido",
                  "text": "3. 1-Click Upsell na Página de Obrigado (R$ 97)",
                  "color": "#047857",
                  "badge": "Margem Líquida Pura",
                  "side": "right",
                  "order": 2,
                  "isCollapsed": false,
                  "note": "Oferta imediata apresentada logo após o pagamento do cronograma, aproveitando o momento de maior confiança do comprador."
            },
            "n1_upsell_redacao": {
                  "id": "n1_upsell_redacao",
                  "parentId": "n1_upsell_bloco",
                  "text": "'Curso Express de Redação Militar Nota 1000' (R$ 97)",
                  "badge": "Take Rate 18%",
                  "side": "right",
                  "order": 0,
                  "note": "10 Esqueletos prontos coringa anti-zeramento de redação dissertativa para carreiras policiais."
            },
            "n1_upsell_video_60s": {
                  "id": "n1_upsell_video_60s",
                  "parentId": "n1_upsell_bloco",
                  "text": "Vídeo de 60 Segundos na Página de Obrigado",
                  "side": "right",
                  "order": 1,
                  "note": "'Não saia desta página: a redação elimina 40% dos candidatos na PM. Garanta o gabarito das redações por apenas R$ 97 com um clique.'"
            },
            "n1_wpp_rapido_bloco": {
                  "id": "n1_wpp_rapido_bloco",
                  "parentId": "ramo_n1_caixa_rapido",
                  "text": "4. Funil Rápido no WhatsApp (Diagnóstico X1)",
                  "color": "#10b981",
                  "badge": "Conversão 30%",
                  "side": "right",
                  "order": 3,
                  "isCollapsed": false,
                  "note": "Canal alternativo de geração rápida de caixa diário via atendimento humanizado e qualificação rápida."
            },
            "n1_wpp_anuncio_raiox": {
                  "id": "n1_wpp_anuncio_raiox",
                  "parentId": "n1_wpp_rapido_bloco",
                  "text": "Anúncio de 'Raio-X Gratuito de Estudos Militar'",
                  "side": "right",
                  "order": 0,
                  "note": "Chamada direta no Meta: 'Quer saber onde você está errando na preparação? Fale com nosso instrutor no WhatsApp agora.'"
            },
            "n1_wpp_triagem_auto": {
                  "id": "n1_wpp_triagem_auto",
                  "parentId": "n1_wpp_rapido_bloco",
                  "text": "Triagem Rápida: Idade, Horas Livres & Concurso Alvo",
                  "side": "right",
                  "order": 1,
                  "note": "4 perguntas para filtrar se o candidato tem perfil para ESA, EsPCEx, PM ou Polícia Civil."
            },
            "n1_wpp_fechamento_pix": {
                  "id": "n1_wpp_fechamento_pix",
                  "parentId": "n1_wpp_rapido_bloco",
                  "text": "Fechamento Imediato no Pix do Combo R$ 97 ou R$ 197",
                  "badge": "Venda no Áudio",
                  "side": "right",
                  "order": 2,
                  "note": "Closer envia áudio de alta energia com postura militar quebrando objeções e gerando chave Pix na hora."
            },
            "n1_matriz_fin_bloco": {
                  "id": "n1_matriz_fin_bloco",
                  "parentId": "ramo_n1_caixa_rapido",
                  "text": "5. Matriz Financeira & Economia Unitária (SLO)",
                  "color": "#059669",
                  "badge": "Matemática do Breakeven",
                  "side": "right",
                  "order": 4,
                  "isCollapsed": false,
                  "note": "Modelagem financeira detalhada para operação auto-sustentável de tráfego pago."
            },
            "n1_fin_ticket_medio": {
                  "id": "n1_fin_ticket_medio",
                  "parentId": "n1_matriz_fin_bloco",
                  "text": "Ticket Médio Consolidado: R$ 58,00 a R$ 68,00",
                  "badge": "Efeito Bumps + Upsell",
                  "side": "right",
                  "order": 0,
                  "note": "Produto base R$ 37 + R$ 19,90 (40%) + R$ 14,90 (25%) + R$ 97 (18%) resulta em ticket médio superior a R$ 58."
            },
            "n1_fin_cpa_alvo": {
                  "id": "n1_fin_cpa_alvo",
                  "parentId": "n1_matriz_fin_bloco",
                  "text": "CPA Alvo no Meta Ads: R$ 30,00 a R$ 35,00",
                  "side": "right",
                  "order": 1,
                  "note": "Custo por aquisição máximo permitido para garantir margem positiva no mesmo dia."
            },
            "n1_fin_roas_diario": {
                  "id": "n1_fin_roas_diario",
                  "parentId": "n1_matriz_fin_bloco",
                  "text": "ROAS Diário Consolidado: 1.6x a 2.0x",
                  "badge": "Lucro Imediato",
                  "side": "right",
                  "order": 2,
                  "note": "A cada R$ 100 investidos em anúncios, voltam R$ 160 a R$ 200 no caixa da empresa."
            },
            "n1_fin_objetivo_cac_zero": {
                  "id": "n1_fin_objetivo_cac_zero",
                  "parentId": "n1_matriz_fin_bloco",
                  "text": "Objetivo Estratégico: CAC Zero & Alunos Pagantes",
                  "badge": "Combustível do Nível 2",
                  "side": "right",
                  "order": 3,
                  "note": "Os compradores do front-end são os leads mais quentes e qualificados para comprar o curso de R$ 997 no Nível 2."
            },
            "n1_trafego_direto_bloco": {
                  "id": "n1_trafego_direto_bloco",
                  "parentId": "ramo_n1_caixa_rapido",
                  "text": "6. Tráfego Direto para LP (Script Idade Limite)",
                  "color": "#10b981",
                  "badge": "Última Oportunidade",
                  "side": "right",
                  "order": 5,
                  "isCollapsed": false,
                  "note": "A estratégia de tráfego direto de maior conversão do nicho militar, alavancando a dor inegociável da idade limite das bancas."
            },
            "n1_td_psicologia_limite": {
                  "id": "n1_td_psicologia_limite",
                  "parentId": "n1_trafego_direto_bloco",
                  "text": "O Gatilho da Idade Limite (ESA 24 anos, PM 30/32 anos)",
                  "badge": "Urgência Biológica",
                  "side": "right",
                  "order": 0,
                  "note": "Ao contrário de outros nichos, nos concursos militares o relógio não espera: passou da idade, a porta se fecha para sempre."
            },
            "n1_td_script_policia": {
                  "id": "n1_td_script_policia",
                  "parentId": "n1_trafego_direto_bloco",
                  "text": "Script 1: Carreiras Policiais (Segmentação 24 a 31 anos)",
                  "badge": "PM / PC",
                  "side": "right",
                  "order": 1,
                  "note": "'Você que tem 27, 28, 29 ou 30 anos: o próximo concurso da PM é a sua ÚLTIMA oportunidade de vestir a farda. O relógio da banca tá correndo contra você. Quando bater a idade limite, acabou. Vai passar o resto da vida no subemprego aguentando humilhação de chefe? Pega o Cronograma Tático de 90 Dias por R$ 37 agora.'"
            },
            "n1_td_script_forcas": {
                  "id": "n1_td_script_forcas",
                  "parentId": "n1_trafego_direto_bloco",
                  "text": "Script 2: Forças Armadas (Segmentação 18 a 23 anos)",
                  "badge": "ESA / EsPCEx",
                  "side": "right",
                  "order": 2,
                  "note": "'Você que tem 21, 22 ou 23 anos e sonha em entrar no Exército: essa é a sua última chance de fazer a prova da ESA antes de bater a idade limite de 24 anos. Bateu a idade, você tá fora. Toma vergonha na cara e pega o Cronograma de 90 Dias por R$ 27.'"
            },
            "n1_td_lp_ultrarrapida": {
                  "id": "n1_td_lp_ultrarrapida",
                  "parentId": "n1_trafego_direto_bloco",
                  "text": "Landing Page Ultrarrápida (<1.8s no Mobile 4G)",
                  "side": "right",
                  "order": 3,
                  "note": "Página enxuta, sem scripts pesados, com VSL curta de 2 minutos demonstrando o cronograma na tela e botão pulsante."
            },
            "n1_td_checkout_integrado": {
                  "id": "n1_td_checkout_integrado",
                  "parentId": "n1_trafego_direto_bloco",
                  "text": "Checkout Transparente Integrado com os 2 Bumps",
                  "badge": "Conversão >12%",
                  "side": "right",
                  "order": 4,
                  "note": "O aluno não sai da página; preenche os dados, marca os bumps de TAF e Questões e paga via Pix em 1 clique."
            },
            "ramo_n2_lancamentos": {
                  "id": "ramo_n2_lancamentos",
                  "parentId": "root_militar_master",
                  "text": "NÍVEL 2: LANÇAMENTOS DE TURMAS (PICOS DE CAIXA)",
                  "color": "#a855f7",
                  "badge": "R$ 50K A R$ 200K+ / TURMA",
                  "shape": "card",
                  "side": "right",
                  "order": 1,
                  "isCollapsed": false,
                  "note": "Objetivo central: Gerar grandes injeções de faturamento e autoridade a cada 45 a 60 dias, abrindo turmas fechadas com escassez real e formando uma verdadeira tropa militar, fundamentado nas 28 aulas do Módulo 6 do Pedro Sobral."
            },
            "n2_modelos_bloco": {
                  "id": "n2_modelos_bloco",
                  "parentId": "ramo_n2_lancamentos",
                  "text": "1. Os Modelos de Lançamento Militar",
                  "color": "#c084fc",
                  "badge": "Formatos Validados",
                  "side": "right",
                  "order": 0,
                  "isCollapsed": false,
                  "note": "Formatos testados para validação inicial, grandes campanhas de escala e resposta rápida a editais oficiais."
            },
            "n2_mod_semente": {
                  "id": "n2_mod_semente",
                  "parentId": "n2_modelos_bloco",
                  "text": "Lançamento Semente (Sobral Aula 21 — R$ 1.5k a R$ 3k)",
                  "badge": "Validação Rápida",
                  "side": "right",
                  "order": 0,
                  "note": "10 a 14 dias de captação -> 1 Masterclass única de 3 horas ao vivo no YouTube ('O Plano de Batalha') -> Venda da Turma Pioneira."
            },
            "n2_mod_semana_farda": {
                  "id": "n2_mod_semana_farda",
                  "parentId": "n2_modelos_bloco",
                  "text": "Lançamento Clássico: 'A Semana da Farda' (Sobral Aula 22)",
                  "badge": "Escala Máxima",
                  "side": "right",
                  "order": 1,
                  "isCollapsed": false,
                  "note": "4 Aulas ao vivo no YouTube às 20h com alto impacto emocional, técnico e choque de realidade."
            },
            "n2_mod_cpl1": {
                  "id": "n2_mod_cpl1",
                  "parentId": "n2_mod_semana_farda",
                  "text": "Aula 1 (Seg): O Choque de Realidade & Mapa dos Editais",
                  "side": "right",
                  "order": 0,
                  "note": "Destruição do vitimismo e demonstração das oportunidades de vagas na PM, ESA e Carreiras Policiais."
            },
            "n2_mod_cpl2": {
                  "id": "n2_mod_cpl2",
                  "parentId": "n2_mod_semana_farda",
                  "text": "Aula 2 (Qua): O Método de Guerra (Estudo Ativo sem Encher Linguiça)",
                  "side": "right",
                  "order": 1,
                  "note": "Como render 8 horas estudando apenas 3h por noite através da resolução reversa de questões da banca."
            },
            "n2_mod_cpl3": {
                  "id": "n2_mod_cpl3",
                  "parentId": "n2_mod_semana_farda",
                  "text": "Aula 3 (Sex): Blindagem Mental, Ansiedade & Treino do TAF",
                  "side": "right",
                  "order": 2,
                  "note": "Como controlar o emocional no dia da prova e como se preparar fisicamente para não reprovar na barra/corrida."
            },
            "n2_mod_cpl4": {
                  "id": "n2_mod_cpl4",
                  "parentId": "n2_mod_semana_farda",
                  "text": "Aula 4 (Dom 20h): Ordem de Batalha & Abertura Oficial do Carrinho",
                  "badge": "Pitch da Farda",
                  "side": "right",
                  "order": 3,
                  "note": "Apresentação da oferta do curso completo, stack de bônus, garantia e abertura de vagas para a tropa."
            },
            "n2_mod_meteorico": {
                  "id": "n2_mod_meteorico",
                  "parentId": "n2_modelos_bloco",
                  "text": "Lançamento Meteórico (Grupo VIP WhatsApp — 12h de Vendas)",
                  "badge": "Gatilho Pós-Edital",
                  "side": "right",
                  "order": 2,
                  "note": "Disparo no momento em que sai o Edital Oficial. 5 dias de captação rápida para grupos silenciosos, 3 dias de áudios estilo Evandro Guedes e vendas abertas das 09h às 21h de quinta-feira."
            },
            "n2_mod_desafio": {
                  "id": "n2_mod_desafio",
                  "parentId": "n2_modelos_bloco",
                  "text": "Desafio 7 Dias: 'Semana do Recruta' (Lives 05h01)",
                  "badge": "Engajamento Tribal",
                  "side": "right",
                  "order": 3,
                  "note": "Lives matinais às 05h01 + meta de 30 questões diárias + 20 flexões nos Stories marcando o perfil do professor."
            },
            "n2_fases_trafego_bloco": {
                  "id": "n2_fases_trafego_bloco",
                  "parentId": "ramo_n2_lancamentos",
                  "text": "2. As 5 Fases do Tráfego no Lançamento (Sobral)",
                  "color": "#9333ea",
                  "badge": "Cronograma Temporal",
                  "side": "right",
                  "order": 1,
                  "isCollapsed": false,
                  "note": "Orquestração temporal das campanhas de tráfego baseada nas aulas 04 a 12 do Pedro Sobral."
            },
            "n2_fase_captacao": {
                  "id": "n2_fase_captacao",
                  "parentId": "n2_fases_trafego_bloco",
                  "text": "Fase 1: Captação de Leads (D-21 a D-1)",
                  "badge": "70% Frio / 30% Base",
                  "side": "right",
                  "order": 0,
                  "note": "Captação agressiva no Meta e YouTube direcionando para grupo silencioso de WhatsApp. CPL alvo: R$ 1,80 a R$ 3,50."
            },
            "n2_fase_aquecimento": {
                  "id": "n2_fase_aquecimento",
                  "parentId": "n2_fases_trafego_bloco",
                  "text": "Fase 2: Aquecimento de Base (Nutrição Contínua)",
                  "side": "right",
                  "order": 1,
                  "note": "Envio de vídeos curtos de alunos fardados na viatura da PM e áudios diários de choque de realidade para manter a taxa de abertura alta."
            },
            "n2_fase_lembrete": {
                  "id": "n2_fase_lembrete",
                  "parentId": "n2_fases_trafego_bloco",
                  "text": "Fase 3: Lembrete Agressivo (D-1 e D-Day)",
                  "badge": "Pico de Orçamento 6h Antes",
                  "side": "right",
                  "order": 2,
                  "note": "Concentrar 50% da verba de lembrete nas 6 horas que antecedem a live no YouTube com criativos: 'Hoje às 20h: Não dê desculpa de frouxo.'"
            },
            "n2_fase_evento": {
                  "id": "n2_fase_evento",
                  "parentId": "n2_fases_trafego_bloco",
                  "text": "Fase 4: Durante o Evento (Anúncios 'Estamos Ao Vivo')",
                  "side": "right",
                  "order": 3,
                  "note": "Campanhas ativas no Instagram Stories e Feed enquanto a aula acontece chamando para entrar na sala imediatamente."
            },
            "n2_fase_carrinho": {
                  "id": "n2_fase_carrinho",
                  "parentId": "n2_fases_trafego_bloco",
                  "text": "Fase 5: Carrinho Aberto (Remarketing 1d, 3d, 7d)",
                  "badge": "Recuperação Agressiva",
                  "side": "right",
                  "order": 4,
                  "note": "Remarketing segmentado por intenção: quebra de objeções de falta de tempo/dinheiro, depoimentos de aprovados e contagem regressiva de encerramento."
            },
            "n2_entressafra_bloco": {
                  "id": "n2_entressafra_bloco",
                  "parentId": "ramo_n2_lancamentos",
                  "text": "3. Gestão de Entressafra & Distribuição (Sobral Aula 13)",
                  "color": "#7e22ce",
                  "badge": "Pixel Aquecido",
                  "side": "right",
                  "order": 2,
                  "note": "Nunca pausar o tráfego entre um lançamento e outro. Manter R$ 30 a R$ 50/dia distribuindo vídeos para baratear o CPL do próximo lançamento."
            },
            "n2_oferta_curso_bloco": {
                  "id": "n2_oferta_curso_bloco",
                  "parentId": "ramo_n2_lancamentos",
                  "text": "4. Oferta: Curso Preparatório Completo (Core Offer)",
                  "color": "#6b21a8",
                  "badge": "Carro-Chefe R$ 697 - R$ 997",
                  "side": "right",
                  "order": 3,
                  "isCollapsed": false,
                  "note": "O curso preparatório oficial vendido nos lançamentos para formação da nova tropa de aprovados."
            },
            "n2_oferta_preco": {
                  "id": "n2_oferta_preco",
                  "parentId": "n2_oferta_curso_bloco",
                  "text": "Preço: R$ 697 a R$ 997 (ou 12x de R$ 69 a R$ 99)",
                  "badge": "Condição Especial Lançamento",
                  "side": "right",
                  "order": 0,
                  "note": "Ancoragem de valor em R$ 3.000 comparado com cursinhos presenciais tradicionais caros e ineficientes."
            },
            "n2_oferta_entrega": {
                  "id": "n2_oferta_entrega",
                  "parentId": "n2_oferta_curso_bloco",
                  "text": "Entrega: Videoaulas Direto ao Ponto + Simulados Mensais",
                  "side": "right",
                  "order": 1,
                  "note": "Aulas de 15 a 20 minutos com teoria enxuta e resolução imediata de dezenas de questões da banca."
            },
            "n2_oferta_stack_bonus": {
                  "id": "n2_oferta_stack_bonus",
                  "parentId": "n2_oferta_curso_bloco",
                  "text": "Stack de Bônus: Vade Mecum + Preparatório TAF + Comunidade",
                  "side": "right",
                  "order": 2,
                  "note": "Bônus que destroem qualquer hesitação: legislação compilada, guia de treino físico e grupo fechado de alunos."
            },
            "n2_oferta_garantia_dupla": {
                  "id": "n2_oferta_garantia_dupla",
                  "parentId": "n2_oferta_curso_bloco",
                  "text": "Garantia Incondicional 7 Dias + Garantia Condicional 1 Ano",
                  "badge": "Risco Zero",
                  "side": "right",
                  "order": 3,
                  "note": "7 dias para testar sem risco. Se cumprir 100% das metas por 1 ano e não for aprovado, devolve o valor + R$ 500 do bolso."
            },
            "ramo_n3_perpetuo": {
                  "id": "ramo_n3_perpetuo",
                  "parentId": "root_militar_master",
                  "text": "NÍVEL 3: PERPÉTUO & ESCALA 24/7 (MÁQUINA AUTOMÁTICA)",
                  "color": "#388bfd",
                  "badge": "PREVISIBILIDADE TOTAL",
                  "shape": "card",
                  "side": "left",
                  "order": 0,
                  "isCollapsed": false,
                  "note": "Objetivo central: Garantir fluxo financeiro previsível todos os dias do ano sem depender do ciclo e do estresse de lançamentos, fundamentado nas 15 aulas do Módulo 7 do Pedro Sobral."
            },
            "n3_pilares_bloco": {
                  "id": "n3_pilares_bloco",
                  "parentId": "ramo_n3_perpetuo",
                  "text": "1. Os 4 Pilares Inegociáveis do Perpétuo (Sobral)",
                  "color": "#60a5fa",
                  "badge": "Fundamentos Técnicos",
                  "side": "left",
                  "order": 0,
                  "isCollapsed": false,
                  "note": "A estrutura de sustentação obrigatória para qualquer perpétuo escalar de forma saudável e consistente."
            },
            "n3_pilar_oferta": {
                  "id": "n3_pilar_oferta",
                  "parentId": "n3_pilares_bloco",
                  "text": "Pilar 1: Oferta Irresistível (Promessa Forte + Bônus)",
                  "side": "left",
                  "order": 0,
                  "note": "A promessa precisa resolver a maior dor do concurseiro e apresentar valor percebido 10x maior que o preço."
            },
            "n3_pilar_persona": {
                  "id": "n3_pilar_persona",
                  "parentId": "n3_pilares_bloco",
                  "text": "Pilar 2: Persona Militar (Sair da Miséria -> Portar a Farda)",
                  "side": "left",
                  "order": 1,
                  "note": "Linguagem focada no resgate da dignidade, na humilhação do trabalho atual e no sonho da posse militar."
            },
            "n3_pilar_pv_rapida": {
                  "id": "n3_pilar_pv_rapida",
                  "parentId": "n3_pilares_bloco",
                  "text": "Pilar 3: Página de Vendas Veloz (<1.8s Mobile-First)",
                  "badge": "Connect Rate >80%",
                  "side": "left",
                  "order": 2,
                  "note": "Página leve, sem elementos pesados desnecessários, com checkout transparente e botão flutuante."
            },
            "n3_pilar_trafego_cont": {
                  "id": "n3_pilar_trafego_cont",
                  "parentId": "n3_pilares_bloco",
                  "text": "Pilar 4: Tráfego Pago Contínuo (70% Frio + 30% Remarketing)",
                  "side": "left",
                  "order": 3,
                  "note": "Alimentação constante do pixel com novos públicos frios para evitar exaustão e encarecimento do CPA."
            },
            "n3_motores_bloco": {
                  "id": "n3_motores_bloco",
                  "parentId": "ramo_n3_perpetuo",
                  "text": "2. Os 4 Motores de Funil Perpétuo",
                  "color": "#2563eb",
                  "badge": "Engrenagens de Conversão",
                  "side": "left",
                  "order": 1,
                  "isCollapsed": false,
                  "note": "Diferentes caminhos de conversão para capturar desde o aluno que compra por vídeo até quem precisa de atendimento consultivo."
            },
            "n3_mot_vsl_cine": {
                  "id": "n3_mot_vsl_cine",
                  "parentId": "n3_motores_bloco",
                  "text": "Motor 1: VSL Cinematográfica de Alto Impacto (Core R$ 697)",
                  "badge": "Alta Conversão",
                  "side": "left",
                  "order": 0,
                  "note": "Vídeo de 20 minutos com produção estilo documentário/filme de ação: viatura, som de sirene, história real de superação e pitch liberado aos 16 minutos."
            },
            "n3_mot_mentoria_high": {
                  "id": "n3_mot_mentoria_high",
                  "parentId": "n3_motores_bloco",
                  "text": "Motor 2: Mentoria High-Ticket 'Tropa de Choque' (R$ 1.997 - R$ 4.997)",
                  "badge": "Margem de 90%",
                  "side": "left",
                  "order": 1,
                  "note": "Acompanhamento individualizado 1 a 1 com policiais e oficiais aprovados. Venda exclusiva por formulário de aplicação e fechamento no WhatsApp X1."
            },
            "n3_mot_mentoria_detalhes": {
                  "id": "n3_mot_mentoria_detalhes",
                  "parentId": "n3_mot_mentoria_high",
                  "text": "Encontros Quinzenais no Zoom + Análise Individual de Rendimento",
                  "side": "left",
                  "order": 0,
                  "note": "Cobrança militar rigorosa de metas semanais de questões resolvidas e simulados com correção detalhada."
            },
            "n3_mot_webinario_auto": {
                  "id": "n3_mot_webinario_auto",
                  "parentId": "n3_motores_bloco",
                  "text": "Motor 3: Webinário Perpétuo Automatizado",
                  "badge": "Escala Passiva",
                  "side": "left",
                  "order": 2,
                  "note": "Aula Magna rodando automaticamente a cada 15 minutos simulando evento ao vivo com chat ativo e contagem regressiva de encerramento."
            },
            "n3_mot_wpp_perpetuo": {
                  "id": "n3_mot_wpp_perpetuo",
                  "parentId": "n3_motores_bloco",
                  "text": "Motor 4: WhatsApp X1 Perpétuo (Closer Militar)",
                  "badge": "Conversão de 25%",
                  "side": "left",
                  "order": 3,
                  "note": "Tráfego frio chamando para diagnóstico com o time de inteligência. Atendimento humanizado fecha o curso de R$ 697 ou Mentoria de R$ 1.997."
            },
            "n3_rmkt_cascata_bloco": {
                  "id": "n3_rmkt_cascata_bloco",
                  "parentId": "ramo_n3_perpetuo",
                  "text": "3. Remarketing em Cascata Multicamadas (Sobral Aula 11)",
                  "color": "#1d4ed8",
                  "badge": "Sequência por Janela",
                  "side": "left",
                  "order": 2,
                  "isCollapsed": false,
                  "note": "A regra de ouro do Pedro Sobral: nunca mostre o mesmo anúncio repetido para quem visitou sua página."
            },
            "n3_rmkt_0_3d": {
                  "id": "n3_rmkt_0_3d",
                  "parentId": "n3_rmkt_cascata_bloco",
                  "text": "Janela 0 a 3 Dias: Quebra de Objeção ('Sem Tempo ou Sem Dinheiro?')",
                  "badge": "Alta Intenção",
                  "side": "left",
                  "order": 0,
                  "note": "'Você viu a página e amarelou? O que tá te travando? O medo ou a preguiça? Clica e garante sua vaga.'"
            },
            "n3_rmkt_4_7d": {
                  "id": "n3_rmkt_4_7d",
                  "parentId": "n3_rmkt_cascata_bloco",
                  "text": "Janela 4 a 7 Dias: Prova Social Visceral (Ex-Aluno na Viatura)",
                  "badge": "Depoimento Real",
                  "side": "left",
                  "order": 1,
                  "note": "Vídeo do aluno que trabalhava de entregador ou servente e hoje pilota a viatura da PM com o salário na conta."
            },
            "n3_rmkt_8_15d": {
                  "id": "n3_rmkt_8_15d",
                  "parentId": "n3_rmkt_cascata_bloco",
                  "text": "Janela 8 a 15 Dias: Escassez da Condição Atual + Garantia 7 Dias",
                  "badge": "Risco Zero",
                  "side": "left",
                  "order": 2,
                  "note": "'Última chamada antes de encerrar o bônus: você tem 7 dias de garantia incondicional. O risco é 100% meu.'"
            },
            "n3_crescimento_bloco": {
                  "id": "n3_crescimento_bloco",
                  "parentId": "ramo_n3_perpetuo",
                  "text": "4. Campanhas de Crescimento & Distribuição (Sobral Aula 12)",
                  "color": "#1e40af",
                  "badge": "Atração de Novos Seguidores",
                  "side": "left",
                  "order": 3,
                  "note": "Campanhas contínuas de distribuição de cortes com objetivo de Visitas ao Perfil do Instagram para renovar a base."
            },
            "ramo_taticas_operacao": {
                  "id": "ramo_taticas_operacao",
                  "parentId": "root_militar_master",
                  "text": "DIRETRIZES TÁTICAS: MÍDIA, SCRIPTS & MÉTRICAS SUBIDO",
                  "color": "#f59e0b",
                  "badge": "DISCIPLINA OPERACIONAL",
                  "shape": "card",
                  "side": "left",
                  "order": 1,
                  "isCollapsed": false,
                  "note": "Os canais de mídia obrigatórios, os scripts completos do Evandro Guedes, as regras de corte financeiro e a nomenclatura oficial Subido."
            },
            "tat_canais_bloco": {
                  "id": "tat_canais_bloco",
                  "parentId": "ramo_taticas_operacao",
                  "text": "1. Canais de Mídia & Segmentação de Públicos",
                  "color": "#fbbf24",
                  "badge": "Multi-Plataforma",
                  "side": "left",
                  "order": 0,
                  "isCollapsed": false,
                  "note": "Estratégia integrada de aquisição cobrindo Meta, YouTube e TikTok."
            },
            "tat_canal_meta": {
                  "id": "tat_canal_meta",
                  "parentId": "tat_canais_bloco",
                  "text": "Meta Ads (Facebook & Instagram)",
                  "badge": "Volume Principal",
                  "side": "left",
                  "order": 0,
                  "note": "Posicionamentos obrigatórios: Reels/Stories (9:16) verticais e Feed (1:1). Exclusão obrigatória de compradores dos últimos 180 dias."
            },
            "tat_meta_interesses": {
                  "id": "tat_meta_interesses",
                  "parentId": "tat_canal_meta",
                  "text": "Interesses: Exército, PM, BOPE, ROTA, Armas, CrossFit, AlfaCon",
                  "side": "left",
                  "order": 0,
                  "note": "Segmentação por afinidade cultural e preparação de carreira."
            },
            "tat_meta_lookalikes": {
                  "id": "tat_meta_lookalikes",
                  "parentId": "tat_canal_meta",
                  "text": "Lookalikes 1% e 2% de Compradores do Nível 1 e Leads",
                  "side": "left",
                  "order": 1,
                  "note": "Públicos semelhantes mais quentes alimentados pelas vendas do front-end."
            },
            "tat_meta_broad": {
                  "id": "tat_meta_broad",
                  "parentId": "tat_canal_meta",
                  "text": "Broad / Aberto: Segmentado por Idade (Criativo como Filtro)",
                  "badge": "Escala Infinita",
                  "side": "left",
                  "order": 2,
                  "note": "Homens 17-24 (Forças Armadas) ou 18-35 (Polícias). O gancho do vídeo faz o filtro algorítmico natural."
            },
            "tat_canal_youtube": {
                  "id": "tat_canal_youtube",
                  "parentId": "tat_canais_bloco",
                  "text": "YouTube Ads (A Mina de Ouro do Público Militar)",
                  "badge": "Maior Intenção",
                  "side": "left",
                  "order": 1,
                  "note": "O concurseiro militar estuda e busca motivação no YouTube. Canais de ocorrências policiais e formaturas têm altíssima conversão."
            },
            "tat_yt_instream": {
                  "id": "tat_yt_instream",
                  "parentId": "tat_canal_youtube",
                  "text": "In-Stream Pulável antes de AMAN, ROTA e Cortes Policiais",
                  "side": "left",
                  "order": 0,
                  "note": "O anúncio entra exatamente quando o candidato está assistindo operações da ROTA ou entrevistas do Evandro Guedes."
            },
            "tat_yt_search": {
                  "id": "tat_yt_search",
                  "parentId": "tat_canal_youtube",
                  "text": "Rede de Pesquisa (Google Search): Fundo de Funil Ativo",
                  "side": "left",
                  "order": 1,
                  "note": "'concurso esa 2026', 'edital pm sp', 'curso preparatorio carreiras policiais', 'simulado pm'."
            },
            "tat_canal_tiktok": {
                  "id": "tat_canal_tiktok",
                  "parentId": "tat_canais_bloco",
                  "text": "TikTok Ads (Jovens de 17 a 22 anos)",
                  "badge": "CPM R$ 3,00",
                  "side": "left",
                  "order": 2,
                  "note": "Excelente para carreiras de entrada (ESA, EsPCEx, EEAR, Aprendiz de Marinheiro) captando leads baratos no WhatsApp."
            },
            "tat_scripts_bloco": {
                  "id": "tat_scripts_bloco",
                  "parentId": "ramo_taticas_operacao",
                  "text": "2. Os 3 Scripts Faca na Caveira (Evandro Guedes)",
                  "color": "#d97706",
                  "badge": "Prontos para Gravação",
                  "side": "left",
                  "order": 1,
                  "isCollapsed": false,
                  "note": "Scripts viscerais prontos para gravação com camiseta preta justa ou farda operacional em estúdio escuro contrastado."
            },
            "tat_script_choque": {
                  "id": "tat_script_choque",
                  "parentId": "tat_scripts_bloco",
                  "text": "Script 1: O Choque no Ônibus 6h da Manhã (Topo de Funil)",
                  "badge": "Despertar da Vítima",
                  "side": "left",
                  "order": 0,
                  "note": "'Segunda-feira, 6h da manhã. O despertador toca e você já acorda com ódio de ir para aquele trabalho bosta onde seu chefe não te respeita e você ganha uma miséria. Até quando você vai aceitar essa vida medíocre? Eu já andei de sapato furado, mas engoli o choro e mudei de vida pelo concurso. A diferença entre quem tá na viatura fardado e você é vergonha na cara e método. Clica e pega o cronograma.'"
            },
            "tat_script_contraste": {
                  "id": "tat_script_contraste",
                  "parentId": "tat_scripts_bloco",
                  "text": "Script 2: O Contraste Social - Dor do Fracasso vs Disciplina",
                  "badge": "Meio de Funil",
                  "side": "left",
                  "order": 1,
                  "note": "'Você tem dois caminhos nos próximos 12 meses. E os dois vão doer. A primeira dor é a dor do fracasso: continuar pegando ônibus lotado e contando moeda. A segunda dor é a dor da disciplina: acordar mais cedo e fazer questão até a mão doer. A dor da disciplina passa; a honra da farda e a estabilidade são para sempre. Escolha sua dor.'"
            },
            "tat_script_marmita": {
                  "id": "tat_script_marmita",
                  "parentId": "tat_scripts_bloco",
                  "text": "Script 3: A Marmita Fria - Quebra de Desculpas (Remarketing)",
                  "badge": "Fim das Desculpas",
                  "side": "left",
                  "order": 2,
                  "note": "'‘Ai, não tenho tempo porque trabalho 10 horas’. Para de dar desculpa de frouxo! Eu estudava com resumo no bolso da calça comendo marmita fria no ponto de ônibus. Quem quer dá um jeito, quem não quer dá desculpa. A prova só quer saber se você acertou a questão. Você viu a página e amarelou. Tem 7 dias de garantia incondicional. Clica agora.'"
            },
            "tat_nomenclatura_bloco": {
                  "id": "tat_nomenclatura_bloco",
                  "parentId": "ramo_taticas_operacao",
                  "text": "3. Nomenclatura Oficial Subido no Gerenciador",
                  "color": "#b45309",
                  "badge": "Padrão de Combate",
                  "side": "left",
                  "order": 2,
                  "isCollapsed": false,
                  "note": "Organização cirúrgica de campanhas ensinada nas aulas 15, 17 e 23 do Pedro Sobral."
            },
            "tat_nom_formula": {
                  "id": "tat_nom_formula",
                  "parentId": "tat_nomenclatura_bloco",
                  "text": "Fórmula Padrão: [NIVEL] - [PRODUTO] - [ETAPA] - [PUBLICO] - [CRIATIVO]",
                  "side": "left",
                  "order": 0,
                  "note": "Permite filtrar e bater o olho no gerenciador sabendo exatamente o que cada centavo está gerando."
            },
            "tat_nom_ex_n1": {
                  "id": "tat_nom_ex_n1",
                  "parentId": "tat_nomenclatura_bloco",
                  "text": "Exemplo Nível 1: [N1_CAIXA] - [CRONOGRAMA_90D] - [VENDA] - [BROAD_17_24] - [VIDEO_IDADE_LIMITE]",
                  "side": "left",
                  "order": 1,
                  "note": "Campanha de venda direta do front-end com script da última chance."
            },
            "tat_nom_ex_n2": {
                  "id": "tat_nom_ex_n2",
                  "parentId": "tat_nomenclatura_bloco",
                  "text": "Exemplo Nível 2: [N2_LANC] - [SEMANA_FARDA] - [CAPTACAO] - [INTERESSES_MILITARES] - [VIDEO_FARDA_02]",
                  "side": "left",
                  "order": 2,
                  "note": "Campanha de captação de leads para o lançamento clássico."
            },
            "tat_nom_ex_n3": {
                  "id": "tat_nom_ex_n3",
                  "parentId": "tat_nomenclatura_bloco",
                  "text": "Exemplo Nível 3: [N3_PERP] - [CORE_697] - [RMKT_0_3D] - [CHECKOUT_VISITANTES] - [VIDEO_MARMITA_03]",
                  "side": "left",
                  "order": 3,
                  "note": "Campanha de remarketing de carrinho no perpétuo."
            },
            "tat_metricas_bloco": {
                  "id": "tat_metricas_bloco",
                  "parentId": "ramo_taticas_operacao",
                  "text": "4. Métricas Inegociáveis & Regras de Escala (Sobral Aula 19)",
                  "color": "#92400e",
                  "badge": "KPIs Invioláveis",
                  "side": "left",
                  "order": 3,
                  "isCollapsed": false,
                  "note": "Parâmetros exatos de controle de orçamento e tomada de decisão rápida no dia a dia."
            },
            "tat_kpi_ctr_cpc": {
                  "id": "tat_kpi_ctr_cpc",
                  "parentId": "tat_metricas_bloco",
                  "text": "CTR no Link > 1,8% e CPC < R$ 0,60 no Meta Ads",
                  "side": "left",
                  "order": 0,
                  "note": "Se o CTR cair abaixo de 1,2%, o Hook inicial do vídeo está fraco e precisa ser trocado imediatamente."
            },
            "tat_kpi_connect_rate": {
                  "id": "tat_kpi_connect_rate",
                  "parentId": "tat_metricas_bloco",
                  "text": "Connect Rate > 80% (Cliques vs Carregamento da LP)",
                  "side": "left",
                  "order": 1,
                  "note": "Mede a velocidade da página: se cair de 80%, as imagens estão pesadas no 4G móvel."
            },
            "tat_kpi_cpl_cap": {
                  "id": "tat_kpi_cpl_cap",
                  "parentId": "tat_metricas_bloco",
                  "text": "CPL na Captação de Lançamento: R$ 1,80 a R$ 3,50",
                  "side": "left",
                  "order": 2,
                  "note": "Custo por lead qualificado com entrada confirmada no grupo de WhatsApp silencioso."
            },
            "tat_kpi_checkout_conv": {
                  "id": "tat_kpi_checkout_conv",
                  "parentId": "tat_metricas_bloco",
                  "text": "Conversão do Checkout > 10% (Visitas -> Vendas)",
                  "side": "left",
                  "order": 3,
                  "note": "Se cair abaixo de 8%, inserir selos de segurança, parcelamento via Pix e prova social no rodapé."
            },
            "tat_kpi_roas_minimo": {
                  "id": "tat_kpi_roas_minimo",
                  "parentId": "tat_metricas_bloco",
                  "text": "ROAS Mínimo no Perpétuo: 1.5x (Front + Bumps)",
                  "badge": "Trava de Lucro",
                  "side": "left",
                  "order": 4,
                  "note": "Garante que a operação gera lucro diário imediato enquanto alimenta os lançamentos."
            },
            "tat_regra_cac_corte": {
                  "id": "tat_regra_cac_corte",
                  "parentId": "tat_metricas_bloco",
                  "text": "Regra do CAC: Gastou 1x o CAC Médio sem Vender -> Pausa Imediata",
                  "badge": "Corte Sem Pena",
                  "side": "left",
                  "order": 5,
                  "note": "Sobral Aula 19: Nunca deixe um conjunto de anúncios gastar mais do que o valor do CPA alvo sem gerar conversão."
            },
            "tat_regra_escala_horiz": {
                  "id": "tat_regra_escala_horiz",
                  "parentId": "tat_metricas_bloco",
                  "text": "Escala Horizontal: 3 a 5 Novos Criativos Toda Semana",
                  "side": "left",
                  "order": 6,
                  "note": "Combate à fadiga de público mantendo os conjuntos vencedores e renovando apenas os ângulos dos vídeos."
            },
            "tat_regra_escala_vert": {
                  "id": "tat_regra_escala_vert",
                  "parentId": "tat_metricas_bloco",
                  "text": "Escala Vertical: Aumentar 15% a 20% do Orçamento a Cada 48h",
                  "badge": "Estabilidade do Algoritmo",
                  "side": "left",
                  "order": 7,
                  "note": "Nunca dobre o orçamento de uma vez só para não desestabilizar a fase de aprendizado da Meta e do Google."
            }
      }
}
  },
  {
    "id": "edservice_growth_partner_operational_machine",
    "title": "MÁQUINA OPERACIONAL EDSERVICE | GROWTH PARTNER",
    "description": "Estrutura mestre de processos, cultura, jornada e funções dos 7 colaboradores baseada na metodologia de entrega e aceleração comercial.",
    "category": "Operação & Agência",
    "badge": "Metodologia T.P.A",
    "data": {
      "rootId": "root_edservice",
      "layout": "map",
      "theme": "dark",
      "defaultNodeShape": "card",
      "viewport": {
        "zoom": 0.85,
        "panX": 800,
        "panY": 500
      },
      "nodes": {
        "root_edservice": {
          "id": "root_edservice",
          "parentId": null,
          "text": "MÁQUINA OPERACIONAL EDSERVICE | GROWTH PARTNER",
          "color": "#6366f1",
          "badge": "METODOLOGIA T.P.A",
          "shape": "card",
          "side": "right",
          "order": 0,
          "isCollapsed": false,
          "note": "VISÃO GERAL DA MÁQUINA OPERACIONAL:\nRepositório central de inteligência da Agência Nichada no modelo Growth Partner.\nTransição definitiva do modelo tradicional falido (posts bonitinhos, artes para feed e baixo ticket) para a Engenharia de Vendas, onde a agência é remunerada pelo Lucro Líquido Real e ROI gerado no caixa do cliente.\n\nARQUITETURA DE MACRO EIXOS:\n1. A EMPRESA (Hemisfério Esquerdo): Cultura inegociável, Metodologia T.P.A, Conceito do PAC, Estrutura Tribe & Squads (limite de 60 clientes) e Políticas/SLAs.\n2. PONTOS DE CONTATO & JORNADA (Hemisfério Esquerdo): Canais oficiais, Régua completa do Dia 0 ao Dia 30, Ritos de comunicação e Protocolo de Queixa + Solução.\n3. ORGANIZAÇÃO DOS 7 COLABORADORES (Hemisfério Direito): Playbooks completos dos 7 cargos (Closer, Financeiro, Gerente Operacional, CS/Especialista, Estrategista, Gestor de Tráfego e Suporte) com PDC, PTI e RCF sem sobreposição."
        },
        "node_empresa": {
          "id": "node_empresa",
          "parentId": "root_edservice",
          "text": "1. A EMPRESA (Cultura, Método & Infra)",
          "color": "#3b82f6",
          "badge": "INSTITUCIONAL",
          "shape": "card",
          "side": "left",
          "order": 0,
          "isCollapsed": false,
          "note": "EIXO ESTRUTURAL 1: A EMPRESA\nFundamentos que sustentam a operação em escala. Todo colaborador que entra na agência é submetido a estes princípios culturais, à metodologia de entrega e ao modelo organizacional de squads."
        },
        "node_empresa_cultura": {
          "id": "node_empresa_cultura",
          "parentId": "node_empresa",
          "text": "1.1 Cultura de Alta Performance & Propósito",
          "color": "#60a5fa",
          "badge": "CULTURA",
          "shape": "card",
          "side": "left",
          "order": 0,
          "isCollapsed": false,
          "note": "PILAR DE CULTURA E PROPÓSITO:\nPrincípios inegociáveis que norteiam todas as decisões e interações do time de entrega com os parceiros."
        },
        "node_cultura_foco_vendas": {
          "id": "node_cultura_foco_vendas",
          "parentId": "node_empresa_cultura",
          "text": "Foco Obsessivo em Vendas & Lucro Líquido (ROI)",
          "color": "#93c5fd",
          "badge": "RESULTADO REAL",
          "shape": "rounded",
          "side": "left",
          "order": 0,
          "isCollapsed": false,
          "note": "A agência existe para colocar dinheiro no bolso do cliente parceiro. Curtidas, comentários e alcance são métricas de vaidade secundárias. Se o cliente não vendeu, o trabalho não está concluído. Todas as reuniões analisam faturamento gerado versus investimento."
        },
        "node_cultura_zero_desculpas": {
          "id": "node_cultura_zero_desculpas",
          "parentId": "node_empresa_cultura",
          "text": "Princípio da Responsabilidade Integral (Zero Desculpas)",
          "color": "#93c5fd",
          "badge": "POSTURA DE DONO",
          "shape": "rounded",
          "side": "left",
          "order": 1,
          "isCollapsed": false,
          "note": "A culpa nunca é do cliente, do algoritmo ou do mercado. Assumimos a liderança técnica do processo. Se o cliente atende mal, nós auditamos e treinamos o atendimento; se o criativo satura, nós produzimos novos ângulos imediatamente."
        },
        "node_cultura_transparencia": {
          "id": "node_cultura_transparencia",
          "parentId": "node_empresa_cultura",
          "text": "Transparência Radical & Alinhamento Preventivo",
          "color": "#93c5fd",
          "badge": "COMUNICAÇÃO ATIVA",
          "shape": "rounded",
          "side": "left",
          "order": 2,
          "isCollapsed": false,
          "note": "Comunicamos vitórias com base em números consolidados e antecipamos gargalos operacionais antes que o cliente precise reclamar. Nunca deixar o cliente no vácuo ou com incertezas sobre o andamento do projeto."
        },
        "node_empresa_metodo_tpa": {
          "id": "node_empresa_metodo_tpa",
          "parentId": "node_empresa",
          "text": "1.2 Metodologia T.P.A (Trindade de Sucesso)",
          "color": "#60a5fa",
          "badge": "MÉTODO MESTRE",
          "shape": "card",
          "side": "left",
          "order": 1,
          "isCollapsed": false,
          "note": "A METODOLOGIA T.P.A:\nA engrenagem tripla que transforma tráfego pago em faturamento escalável no caixa da empresa parceira."
        },
        "node_tpa_trafego": {
          "id": "node_tpa_trafego",
          "parentId": "node_empresa_metodo_tpa",
          "text": "T - Tráfego Pago de Alta Intenção (Meta & Google)",
          "color": "#93c5fd",
          "badge": "GERAÇÃO DE LEADS",
          "shape": "rounded",
          "side": "left",
          "order": 0,
          "isCollapsed": false,
          "note": "Atração contínua e previsível de potenciais compradores. Segmentação orientada a dor e desejo específico do avatar do nicho. Anúncios com roteirização ISI (Interrupção, Solução, Invocação) e teste científico contínuo de variáveis."
        },
        "node_tpa_processo": {
          "id": "node_tpa_processo",
          "parentId": "node_empresa_metodo_tpa",
          "text": "P - Processo Comercial & Funil de Conversão",
          "color": "#93c5fd",
          "badge": "PIPELINE NO CRM",
          "shape": "rounded",
          "side": "left",
          "order": 1,
          "isCollapsed": false,
          "note": "Estruturação e parametrização do CRM de vendas (Kommo / Uai Dash) com etapas claras: Novo Lead, Contato Feito, Agendamento Realizado, Proposta Enviada, Venda Fechada e Perdido (com registro obrigatório do motivo da perda)."
        },
        "node_tpa_atendimento": {
          "id": "node_tpa_atendimento",
          "parentId": "node_empresa_metodo_tpa",
          "text": "A - Atendimento Humanizado em < 5 Minutos",
          "color": "#93c5fd",
          "badge": "REGRA DE OURO",
          "shape": "rounded",
          "side": "left",
          "order": 2,
          "isCollapsed": false,
          "note": "Regra dos 5 Minutos: Responder o lead quente no WhatsApp em menos de 5 minutos da conversão (aumento de 391% na taxa de conversão). Proibição de robôs engessados. Utilização de áudios humanizados, perguntas de qualificação e cadência ativa de 4 a 5 follow-ups."
        },
        "node_empresa_pac": {
          "id": "node_empresa_pac",
          "parentId": "node_empresa",
          "text": "1.3 O PAC (Plano de Aceleração Comercial)",
          "color": "#60a5fa",
          "badge": "PRODUTIZAÇÃO",
          "shape": "card",
          "side": "left",
          "order": 2,
          "isCollapsed": false,
          "note": "CONCEITO DO PAC (PLANO DE ACELERAÇÃO COMERCIAL):\nProdutização da entrega que rompe a armadilha do modelo de agência tradicional."
        },
        "node_pac_produtizacao": {
          "id": "node_pac_produtizacao",
          "parentId": "node_empresa_pac",
          "text": "Setup de Implementação + Assessoria Recorrente",
          "color": "#93c5fd",
          "badge": "MODELO DE COBRANÇA",
          "shape": "rounded",
          "side": "left",
          "order": 0,
          "isCollapsed": false,
          "note": "Cobrança de Taxa de Implementação inicial (ex: R$ 3.000,00) para setup técnico e estruturação do funil + Mensalidade recorrente (ex: R$ 3.000,00/mês). Fim definitivo de contratos baratos de R$ 800,00 a R$ 1.500,00 que sufocam a operação com retrabalho."
        },
        "node_pac_retorno_matematico": {
          "id": "node_pac_retorno_matematico",
          "parentId": "node_empresa_pac",
          "text": "Matemática do Retorno: 2 a 3 Vendas Pagam Tudo",
          "color": "#93c5fd",
          "badge": "VALOR PERCEBIDO",
          "shape": "rounded",
          "side": "left",
          "order": 1,
          "isCollapsed": false,
          "note": "Apresentação da proposta ancorada no valor unitário do produto do cliente. Se o cliente vende procedimentos ou serviços de R$ 1.500,00 a R$ 3.000,00, fechar 2 ou 3 vendas extras no mês já cobre 100% dos custos da assessoria e gera lucro líquido livre no bolso dele."
        },
        "node_empresa_squads": {
          "id": "node_empresa_squads",
          "parentId": "node_empresa",
          "text": "1.4 Estrutura Tribe & Squads (Limite: 60 Clientes)",
          "color": "#60a5fa",
          "badge": "MODELO SPOTIFY",
          "shape": "card",
          "side": "left",
          "order": 3,
          "isCollapsed": false,
          "note": "MODELO DE ORGANIZAÇÃO DE TIMES EM SQUADS:\nArquitetura ágil que garante escalabilidade sem perda de controle ou sobrecarga da equipe de entrega."
        },
        "node_squad_capacidade": {
          "id": "node_squad_capacidade",
          "parentId": "node_empresa_squads",
          "text": "Squad Multidisciplinar (Capacidade: 60 Clientes)",
          "color": "#93c5fd",
          "badge": "BLINDAGEM OPERACIONAL",
          "shape": "rounded",
          "side": "left",
          "order": 0,
          "isCollapsed": false,
          "note": "Trava Operacional Inegociável: Cada Squad atende rigorosamente até 60 clientes parceiros. Acima de 60 clientes, a agência abre um novo Squad completo. Composição: 1 Head de Squad (Líder), 1 Especialista (CS), Gestores de Tráfego e 1 Designer dedicado."
        },
        "node_squad_chapters_guilds": {
          "id": "node_squad_chapters_guilds",
          "parentId": "node_empresa_squads",
          "text": "Tribe, Chapters & Guilds de Inovação",
          "color": "#93c5fd",
          "badge": "DESENVOLVIMENTO",
          "shape": "rounded",
          "side": "left",
          "order": 1,
          "isCollapsed": false,
          "note": "- Tribe: Todo o departamento de operações liderado pelo Diretor de Operações (Diretor Ops).\n- Chapter: Reuniões semanais entre especialistas do mesmo ofício (Chapter de GTs na quinta e Chapter de CS na sexta).\n- Guild: Comunidades de aprendizado transversal (Inovação, Inteligência Artificial, Ferramentas e Clube do Livro)."
        },
        "node_empresa_stack": {
          "id": "node_empresa_stack",
          "parentId": "node_empresa",
          "text": "1.5 Stack Oficial de Ferramentas",
          "color": "#60a5fa",
          "badge": "INFRAESTRUTURA",
          "shape": "card",
          "side": "left",
          "order": 4,
          "isCollapsed": false,
          "note": "ECOSSISTEMA HOMOLOGADO DE TECNOLOGIA:\n- Monday.com: Gestão de tarefas, checklists de onboarding, quadro de saldo diário, quadro de queixas e SLAs.\n- Kommo / Uai Dash CRM: Centralização de conversas de WhatsApp, automação de funis e histórico de oportunidades.\n- Meta Ads, Google Ads & GA4: Gestão de mídia paga, pixels, GTM e acompanhamento de taxas de conversão.\n- WhatsApp API & ZapVoice: Disparos organizados, funis rápidos de atendimento e esteiras sem bloqueio.\n- Google Meet: Plataforma corporativa de reuniões remotas e gravações de alinhamento estratégico."
        },
        "node_empresa_politicas": {
          "id": "node_empresa_politicas",
          "parentId": "node_empresa",
          "text": "1.6 Políticas, SLAs & Comunicação Pivô",
          "color": "#60a5fa",
          "badge": "REGRAS DE OURO",
          "shape": "card",
          "side": "left",
          "order": 5,
          "isCollapsed": false,
          "note": "POLÍTICAS E REGRAS OPERACIONAIS:\n- Horário de Atendimento Corporativo: Segunda a sexta-feira, das 09h às 18h.\n- Regra da Comunicação Pivô: Quando o Head ou o Especialista estão em reuniões de onboarding ou alinhamento com clientes, o Gestor de Tráfego assume obrigatoriamente o atendimento no WhatsApp para que nenhuma mensagem fique sem resposta.\n- SLA no Grupo VIP: Máximo de 15 minutos em horário comercial para acolhimento inicial.\n- SLA de Resolução Técnica: Até 2 horas para ajustes de campanhas, links ou correções de pixel.\n- Postura e Comunicação: Português impecável, áudios objetivos e empáticos, proibição de gírias e segurança nas respostas."
        },
        "node_contatos": {
          "id": "node_contatos",
          "parentId": "root_edservice",
          "text": "2. PONTOS DE CONTATO & JORNADA DO CLIENTE",
          "color": "#06b6d4",
          "badge": "EXPERIÊNCIA LTV",
          "shape": "card",
          "side": "left",
          "order": 1,
          "isCollapsed": false,
          "note": "EIXO ESTRUTURAL 2: PONTOS DE CONTATO & JORNADA\nMapeamento cronológico dos touchpoints oficiais entre a agência e o cliente parceiro, desenhado para gerar encantamento nos primeiros 7 dias e garantir retenção de longo prazo (LTV)."
        },
        "node_contatos_canais": {
          "id": "node_contatos_canais",
          "parentId": "node_contatos",
          "text": "2.1 Canais Oficiais de Relacionamento",
          "color": "#22d3ee",
          "badge": "CANAL ÚNICO",
          "shape": "card",
          "side": "left",
          "order": 0,
          "isCollapsed": false,
          "note": "CANAIS HOMOLOGADOS DE CONTATO:\n- GRUPO VIP NO WHATSAPP:\n  * Canal mestre e oficial do cliente com o Squad: '[NOME DO CLIENTE] | EdService Growth'.\n  * Membros: Cliente + Sócios/Atendentes + Head + Especialista (CS) + Gestor de Tráfego + Suporte.\n  * Regra Inegociável: Proibido atendimento no privado. Toda interação deve ocorrer no grupo VIP para alinhamento geral.\n- GOOGLE MEET:\n  * Reuniões formais agendadas: Kick-off, Alinhamento de Resultados e Retenção. Gravações arquivadas no Monday.\n- PLATAFORMA FINANCEIRA & E-MAIL:\n  * Envio formal de contratos digitais (ClickSign/ZapSign), notas fiscais e comprovantes bancários."
        },
        "node_contatos_d0": {
          "id": "node_contatos_d0",
          "parentId": "node_contatos",
          "text": "2.2 Dia 0: Fechamento & Boas-Vindas",
          "color": "#22d3ee",
          "badge": "DIA ZERO",
          "shape": "card",
          "side": "left",
          "order": 1,
          "isCollapsed": false,
          "note": "PROTOCOLO DO DIA 0 (IMEDIATAMENTE APÓS O SIM):\n1. Assinatura Digital do Contrato: Envio do contrato via ClickSign/ZapSign pelo Closer/Financeiro.\n2. Liquidação da Entrada do PAC: Confirmação do pagamento da taxa de implementação via Pix ou Cartão.\n3. Criação do Grupo VIP: Criação do grupo no WhatsApp com o padrão visual corporativo da agência.\n4. Formulário de Onboarding: Envio do formulário inteligente de briefing (público-alvo, histórico de vendas, concorrentes)."
        },
        "node_contatos_d1": {
          "id": "node_contatos_d1",
          "parentId": "node_contatos",
          "text": "2.3 Dia 1: Recepção & Coleta de Acessos (24h)",
          "color": "#22d3ee",
          "badge": "PRIMEIRAS 24H",
          "shape": "card",
          "side": "left",
          "order": 2,
          "isCollapsed": false,
          "note": "PROTOCOLO DO DIA 1 (PRIMEIRAS 24 HORAS):\n1. Vídeo Personalizado do Head: O Head do Squad grava um vídeo de 1 minuto no WhatsApp acolhendo o cliente, apresentando o Squad e transmitindo autoridade imediata.\n2. Coleta Guiada de Acessos: O Suporte/GT envia tutoriais em vídeo para liberação de acesso de Parceiro ao Gerenciador de Negócios da Meta, Conta de Anúncios e WhatsApp Business.\n3. Auditoria de Ativos: Checagem de saldo, histórico de bloqueios e conformidade das contas."
        },
        "node_contatos_d2": {
          "id": "node_contatos_d2",
          "parentId": "node_contatos",
          "text": "2.4 Dia 2: Reunião de Kick-off (48h)",
          "color": "#22d3ee",
          "badge": "REUNIÃO KICK-OFF",
          "shape": "card",
          "side": "left",
          "order": 3,
          "isCollapsed": false,
          "note": "PROTOCOLO DO DIA 2 (ATÉ 48 HORAS):\n- Reunião de Kick-off via Google Meet (45 minutos).\n- Participantes: Cliente + Head do Squad + Estrategista + Especialista (CS).\n- Pauta Estruturada:\n  1. Alinhamento de expectativas e metas de vendas para os primeiros 30, 60 e 90 dias.\n  2. Validação da Proposta Única de Valor e ofertas que serão anunciadas.\n  3. Mapeamento do fluxo de atendimento do cliente no WhatsApp (tempo de resposta atual e script).\n  4. Apresentação do cronograma de lançamento das campanhas."
        },
        "node_contatos_d3_d5": {
          "id": "node_contatos_d3_d5",
          "parentId": "node_contatos",
          "text": "2.5 Dias 3 a 5: Produção de Ativos & Setup Técnico",
          "color": "#22d3ee",
          "badge": "BASTIDORES",
          "shape": "card",
          "side": "left",
          "order": 4,
          "isCollapsed": false,
          "note": "PROTOCOLO DOS DIAS 3 A 5 (MÃO NA MASSA INTERNA):\n- Roteirização de Criativos: O Estrategista redige os roteiros ISI (Interrupção, Solução, Invocação) específicos para o nicho.\n- Produção Visual: O Designer elabora os criativos em imagem e motion de alta conversão.\n- Setup Técnico Blindado:\n  * Instalação de Pixel e API de Conversões via Google Tag Manager (GTM).\n  * Criação de UTMs personalizadas para rastreamento no CRM.\n  * Estruturação do funil de vendas no Kommo/Uai Dash com tags automáticas."
        },
        "node_contatos_d6_d7": {
          "id": "node_contatos_d6_d7",
          "parentId": "node_contatos",
          "text": "2.6 Dias 6 e 7: Aprovação & Lançamento de Campanhas",
          "color": "#22d3ee",
          "badge": "CAMPANHAS NO AR",
          "shape": "card",
          "side": "left",
          "order": 5,
          "isCollapsed": false,
          "note": "PROTOCOLO DOS DIAS 6 E 7 (ENTRADA EM OPERAÇÃO):\n1. Apresentação e Aprovação: Envio dos criativos e cópias no grupo VIP para validação final do cliente.\n2. Subida das Campanhas: O Gestor de Tráfego programa e ativa as campanhas no Meta Ads e Google Ads.\n3. Notificação Oficial no Grupo:\n   '🚀 CAMPANHAS OFICIALMENTE ATIVADAS! O motor de aquisição está rodando. Time comercial, fiquem atentos ao WhatsApp: lead chegando deve ser atendido em menos de 5 minutos com script humanizado!'\n4. Monitoramento das Primeiras 24h: Checagem de entrega de impressões e primeiros disparos de mensagens."
        },
        "node_contatos_ritos": {
          "id": "node_contatos_ritos",
          "parentId": "node_contatos",
          "text": "2.7 Ritos Periódicos de Comunicação (Semanal & Mensal)",
          "color": "#22d3ee",
          "badge": "CADÊNCIA ATIVA",
          "shape": "card",
          "side": "left",
          "order": 6,
          "isCollapsed": false,
          "note": "RITOS DE GESTÃO E PREVENÇÃO DE CHURN:\n- TODA SEGUNDA-FEIRA (Até 12h):\n  * Envio do Relatório Semanal consolidado com script oficial do Notion no grupo VIP.\n  * Resumo de: Valor investido na semana, total de leads recebidos, custo por lead (CPL) e plano de melhorias da semana.\n- TODA SEXTA-FEIRA (Às 17h):\n  * Mensagem de fechamento de semana: 'Desejamos um excelente final de semana de vendas ao time! Nosso time de tráfego segue monitorando os anúncios em regime de plantão.'\n- FECHAMENTO MENSAL:\n  * Reunião Estratégica de ROI (Google Meet):\n    Faturamento Gerado - Custo de Tráfego - Custo da Assessoria = Lucro Líquido Real.\n  * Apresentação dos dados da planilha de vendas e alinhamento da meta do mês subsequente."
        },
        "node_contatos_queixas": {
          "id": "node_contatos_queixas",
          "parentId": "node_contatos",
          "text": "2.8 Protocolo de Resolução de Queixas (Queixa + Solução)",
          "color": "#22d3ee",
          "badge": "GESTÃO DE CRISE",
          "shape": "card",
          "side": "left",
          "order": 7,
          "isCollapsed": false,
          "note": "FLUXO PADRÃO DE GESTÃO DE QUEIXAS:\nQuando o cliente envia uma reclamação (ex: 'leads desqualificados', 'campanha parou', 'lead não responde'):\n1. Acolhimento Imediato (< 15 minutos): Resposta rápida acolhendo a preocupação do cliente sem apresentar desculpas ou justificar com algoritmo.\n2. Registro no Monday: Cadastro no quadro 'Queixa + Solução' com cliente, dor, gravidade e responsável.\n3. Análise Técnica: GT e Estrategista avaliam criativos, filtros e velocidade de atendimento.\n4. Apresentação da Solução: Informar ao cliente a ação cirúrgica executada para resolver o problema.\n5. Feedback de Satisfação: O Especialista entra em contato 48h depois para validar se o fluxo foi normalizado."
        },
        "node_colaboradores": {
          "id": "node_colaboradores",
          "parentId": "root_edservice",
          "text": "3. ORGANIZAÇÃO DOS 7 COLABORADORES",
          "color": "#10b981",
          "badge": "PLAYBOOKS DE CARGOS",
          "shape": "card",
          "side": "right",
          "order": 0,
          "isCollapsed": false,
          "note": "EIXO ESTRUTURAL 3: PLAYBOOKS DOS 7 COLABORADORES\nEstruturação detalhada, sem sobreposições e com divisão cirúrgica de funções para cada uma das 7 cadeiras fundamentais da agência.\nCada cargo é regido por:\n- PDC (Padrão de Desempenho de Cargo): Missão, responsabilidades e postura.\n- PTI (Procedimento Técnico Individual): Rotina diária e cronograma semanal.\n- RCF (Resultados Chave Finais & KPIs): Métricas inegociáveis de avaliação."
        },
        "node_cargo_closer": {
          "id": "node_cargo_closer",
          "parentId": "node_colaboradores",
          "text": "3.1 Closer (Executivo de Vendas & Fechamento)",
          "color": "#f59e0b",
          "badge": "COMERCIAL",
          "shape": "card",
          "side": "right",
          "order": 0,
          "isCollapsed": false,
          "note": "CARGO 1: CLOSER\nEspecialista em condução de reuniões comerciais de alto impacto e fechamento de contratos de PAC e recorrência. Transforma reuniões qualificadas pelo SDR ou anúncios em clientes pagantes."
        },
        "node_closer_pdc": {
          "id": "node_closer_pdc",
          "parentId": "node_cargo_closer",
          "text": "Closer: PDC (Padrão de Desempenho)",
          "color": "#fbbf24",
          "badge": "MISSÃO & POSTURA",
          "shape": "card",
          "side": "right",
          "order": 0,
          "isCollapsed": false,
          "note": "PDC DO CLOSER:\n- Missão Primordial: Conduzir reuniões de vendas online, diagnosticar gargalos comerciais de empresários, apresentar a solução do método T.P.A/PAC e fechar contratos com ticket de R$ 3.000,00+ com taxa de conversão superior a 25%.\n- Competências Comportamentais: Escuta ativa refinada, oratória persuasiva, segurança emocional absoluta para lidar com objeções, pontualidade britânica e perfil consultivo (médico dos negócios, não tirador de pedidos).\n- Postura Corporativa: Vestimenta profissional em calls, câmera de alta definição, iluminação impecável, ambiente silencioso e postura de autoridade parceira."
        },
        "node_closer_pti_rotina": {
          "id": "node_closer_pti_rotina",
          "parentId": "node_cargo_closer",
          "text": "Closer: PTI (Rotina & Condução da Call 6D)",
          "color": "#fbbf24",
          "badge": "ROTEIRO 6D",
          "shape": "card",
          "side": "right",
          "order": 1,
          "isCollapsed": false,
          "note": "PTI E ROTEIRO DA REUNIÃO 6D (45 MINUTOS):\n1. PREPARAÇÃO PRÉ-CALL (15 min antes):\n   - Auditar o Instagram, site e posicionamento do lead.\n   - Analisar o faturamento atual e histórico preenchido pelo SDR no CRM.\n2. CONDUÇÃO DA REUNIÃO (45 minutos):\n   - D1: Conexão e Rapport Inicial (5 min) - Estabelecer autoridade e quebrar o gelo.\n   - D2: Diagnóstico e Perguntas de Dor (15 min) - Mapear faturamento atual, meta desejada, faturamento perdido por atendimento lento e experiências traumáticas anteriores com agências.\n   - D3: Demonstração da Solução T.P.A (15 min) - Apresentação visual da engrenagem: Tráfego + Processo Comercial + Atendimento.\n   - D4: Proposta Irresistível e Preço (5 min) - Ancoragem do PAC e apresentação dos valores.\n   - D5: Fechamento Direto (5 min) - 'Qual a melhor forma para emitirmos o contrato para sua empresa hoje: no CNPJ ou no CPF?'\n3. PÓS-CALL E CADÊNCIA DE FOLLOW-UP:\n   - Se fechou: Enviar contrato na hora no ClickSign e cobrar entrada via Pix.\n   - Se indeciso: Cadência de follow-up ativa de 24h, 48h e 72h via áudio personalizado no WhatsApp."
        },
        "node_closer_objecoes": {
          "id": "node_closer_objecoes",
          "parentId": "node_cargo_closer",
          "text": "Closer: Arsenal de Quebra de Objeções",
          "color": "#fbbf24",
          "badge": "SCRIPTS REAIS",
          "shape": "card",
          "side": "right",
          "order": 2,
          "isCollapsed": false,
          "note": "MATRIZ DE REENQUADRAMENTO DE OBJEÇÕES:\n- 'Já fiz tráfego pago antes e não funcionou':\n  * 'Exatamente por isso que você está conversando conosco. As agências comuns apenas sobem anúncios e jogam contatos no seu WhatsApp. Nós somos parceiros de crescimento: nós auditamos e estruturamos o seu atendimento comercial antes de abrir a torneira do tráfego. Se o seu processo não vender, nós nem começamos as campanhas.'\n- 'Achei o valor caro / Tenho propostas mais baratas':\n  * 'Caro em relação a quê? Uma agência que te cobra R$ 1.000,00 e não te dá retorno te dá R$ 1.000,00 de prejuízo todo mês. O nosso acompanhamento de R$ 3.000,00 é projetado para gerar R$ 15.000,00 a R$ 25.000,00 de retorno líquido. O que é mais barato: pagar R$ 1.000,00 para ter prejuízo ou investir R$ 3.000,00 para lucrar R$ 20.000,00?'\n- 'Preciso falar com meu sócio':\n  * 'Com certeza. Mas me diga uma coisa: se dependesse exclusivamente de você, você fecharia essa parceria agora? Quais são as 2 principais dúvidas que você acha que ele terá? Vamos agendar uma conversa de 15 minutos com nós três amanhã cedo para que eu mesmo explique a parte técnica e você não precise vender nosso trabalho sozinho.'"
        },
        "node_closer_rcf": {
          "id": "node_closer_rcf",
          "parentId": "node_cargo_closer",
          "text": "Closer: RCF (KPIs & Passagem de Bastão)",
          "color": "#fbbf24",
          "badge": "KPIS DE VENDAS",
          "shape": "card",
          "side": "right",
          "order": 3,
          "isCollapsed": false,
          "note": "RCF E MÉTRICAS DO CLOSER:\n- Taxa de Conversão de Reuniões: Mínimo de 25% a 30% das calls realizadas convertidas em vendas.\n- Faturamento de Novos Contratos: Meta mensal individual de novos contratos de PAC e recorrência.\n- Show-up Rate (Comparecimento): Garantir > 80% de comparecimento através de lembrete 2h antes da call.\n- PROTOCOLO DE PASSAGEM DE BASTÃO (DIA 0):\n  * Preenchimento completo do card do cliente no CRM com histórico, ticket fechado, CNPJ, responsável e dores mapeadas.\n  * Notificação imediata no canal interno para o Financeiro emitir cobrança e para o Head de Operações designar o Squad."
        },
        "node_cargo_financeiro": {
          "id": "node_cargo_financeiro",
          "parentId": "node_colaboradores",
          "text": "3.2 Financeiro (Gestão de Caixa & Faturamento)",
          "color": "#10b981",
          "badge": "FINANÇAS",
          "shape": "card",
          "side": "right",
          "order": 1,
          "isCollapsed": false,
          "note": "CARGO 2: FINANCEIRO\nGuardião da saúde financeira da agência. Responsável pela emissão de cobranças, conciliação bancária diária, fechamento de DRE, fluxo de caixa e gestão de inadimplência."
        },
        "node_fin_pdc": {
          "id": "node_fin_pdc",
          "parentId": "node_cargo_financeiro",
          "text": "Financeiro: PDC (Padrão de Desempenho)",
          "color": "#34d399",
          "badge": "MISSÃO & RIGOR",
          "shape": "card",
          "side": "right",
          "order": 0,
          "isCollapsed": false,
          "note": "PDC DO FINANCEIRO:\n- Missão Primordial: Garantir a liquidação de 100% dos pagamentos de entrada no Dia 0, manter a taxa de inadimplência global abaixo de 3% e entregar a DRE consolidada até o 5º dia útil de cada mês.\n- Perfil: Extrema atenção a detalhes numéricos, organização impecável de documentos fiscais, firmeza e polidez nas cobranças e sigilo absoluto sobre dados bancários e comissionamentos."
        },
        "node_fin_pti_rotina": {
          "id": "node_fin_pti_rotina",
          "parentId": "node_cargo_financeiro",
          "text": "Financeiro: PTI (Rotina de Faturamento & Caixa)",
          "color": "#34d399",
          "badge": "FLUXO DE CAIXA",
          "shape": "card",
          "side": "right",
          "order": 1,
          "isCollapsed": false,
          "note": "PTI DAS ROTINAS FINANCEIRAS:\n- ROTINA DIÁRIA (08h às 12h):\n  * Conciliação Bancária: Conferir entradas e saídas no banco e registrar no software financeiro (Asaas/Conta Azul).\n  * Emissão de Notas Fiscais (NFS-e) para clientes com pagamentos confirmados.\n  * Validação de Entradas do Dia 0: Conferir pagamentos de novos clientes e avisar imediatamente o Head de Operações para liberação do Onboarding.\n- GESTÃO DE RECORRÊNCIA AUTOMATIZADA:\n  * Cobrança em cartão ou boleto com régua automatizada: D-3 (aviso de vencimento), D0 (lembrete no dia), D+1 e D+3 (cobrança ativa)."
        },
        "node_fin_inadimplencia": {
          "id": "node_fin_inadimplencia",
          "parentId": "node_cargo_financeiro",
          "text": "Financeiro: Gestão de Inadimplência & Recuperação",
          "color": "#34d399",
          "badge": "RÉGUA DE COBRANÇA",
          "shape": "card",
          "side": "right",
          "order": 2,
          "isCollapsed": false,
          "note": "RÉGUA DE COBRANÇA DE CLIENTES INADIMPLENTES:\n- Dia +1 do Vencimento: Mensagem cordial no WhatsApp do financeiro do cliente lembrando o boleto vencido com o código de barras atualizado.\n- Dia +3 do Vencimento: Ligação telefônica amigável para entender se houve problema bancário e renegociar prazo.\n- Dia +5 do Vencimento: Aviso formal de suspensão temporária dos serviços e pausa nos anúncios em caso de não liquidação em 24h.\n- Semanas 4 e 5: Alinhamento conjunto com o Head de Operações para repactuação ou distrato formal sem atrito."
        },
        "node_fin_rcf": {
          "id": "node_fin_rcf",
          "parentId": "node_cargo_financeiro",
          "text": "Financeiro: RCF (KPIs & Fechamento DRE)",
          "color": "#34d399",
          "badge": "KPIS FINANCEIROS",
          "shape": "card",
          "side": "right",
          "order": 3,
          "isCollapsed": false,
          "note": "RCF E MÉTRICAS DO FINANCEIRO:\n- Taxa de Inadimplência da Carteira: Abaixo de 3% ao mês.\n- Prazo de Emissão da DRE: Entregue aos sócios até o 5º dia útil de cada mês com margem líquida calculada.\n- Liquidação de Contratos no Dia 0: 100% dos novos contratos com entrada quitada antes do início da operação.\n- Organização de Contratos e Comprovantes: 100% dos arquivos arquivados na pasta segura do Google Drive."
        },
        "node_cargo_head": {
          "id": "node_cargo_head",
          "parentId": "node_colaboradores",
          "text": "3.3 Gerente Operacional (Head de Squad)",
          "color": "#8b5cf6",
          "badge": "LIDERANÇA DE SQUAD",
          "shape": "card",
          "side": "right",
          "order": 2,
          "isCollapsed": false,
          "note": "CARGO 3: GERENTE OPERACIONAL (HEAD DE OPERAÇÕES)\nLíder do Squad de até 60 clientes. Colaborador de confiança total da agência, responsável por coordenar a entrega, liderar reuniões estratégicas, prevenir cancelamentos (churn) e desenvolver os liderados do squad."
        },
        "node_head_pdc": {
          "id": "node_head_pdc",
          "parentId": "node_cargo_head",
          "text": "Head: PDC (Padrão de Desempenho)",
          "color": "#a78bfa",
          "badge": "LIDERANÇA & FOCO",
          "shape": "card",
          "side": "right",
          "order": 0,
          "isCollapsed": false,
          "note": "PDC DO GERENTE OPERACIONAL (HEAD):\n- Missão Primordial: Garantir a excelência e os prazos de entrega do Squad de até 60 clientes, manter a taxa de churn mensal abaixo de 3%, conduzir reuniões de alinhamento e ser o exemplo técnico e comportamental da equipe.\n- Perfil: Altamente organizado, comunicativo, apaixonado por processos, líder exemplar com pulso firme e empatia, capacidade de acalmar clientes em momentos de crise."
        },
        "node_head_pti_diario": {
          "id": "node_head_pti_diario",
          "parentId": "node_cargo_head",
          "text": "Head: PTI (Rotina Diária de Seg a Sex)",
          "color": "#a78bfa",
          "badge": "ROTINA DIÁRIA",
          "shape": "card",
          "side": "right",
          "order": 1,
          "isCollapsed": false,
          "note": "ROTINA DIÁRIA DO HEAD DE OPERAÇÕES:\n- SEGUNDA-FEIRA:\n  * 08h30: Bom dia oficial em todos os grupos VIP de clientes do Squad.\n  * 09h30: Auditoria do quadro de queixas do Monday.com.\n  * 14h00: Weekly oficial do Squad (alinhamento de prioridades da semana).\n  * 16h00: Check-up geral de tarefas e prazos do Monday.\n- TERÇA-FEIRA:\n  * Conferência geral dos grupos VIP e Monday.\n  * Treinamento semanal técnico com o Squad (alinhamento de boas práticas).\n  * Reuniões de 1-on-1 com os Gestores de Tráfego.\n- QUARTA-FEIRA:\n  * Auditoria de preenchimento do Monday e acompanhamento de campanhas que precisam de tração.\n- QUINTA-FEIRA:\n  * Participação na call semanal dos CS (Chapter de Especialistas).\n  * Participação na call semanal dos GTs (Chapter de Tráfego).\n- SEXTA-FEIRA:\n  * 1-on-1 com o Especialista (CS) do Squad.\n  * Planejamento estratégico da semana seguinte.\n  * Mensagem oficial de bom final de semana em todos os grupos."
        },
        "node_head_pti_mensal": {
          "id": "node_head_pti_mensal",
          "parentId": "node_cargo_head",
          "text": "Head: PTI (Ciclo Mensal das 4 Semanas)",
          "color": "#a78bfa",
          "badge": "CICLO MENSAL",
          "shape": "card",
          "side": "right",
          "order": 2,
          "isCollapsed": false,
          "note": "CICLO MENSAL DO HEAD DE OPERAÇÕES:\n- SEMANA 1:\n  * Reunião mensal com todo o Squad para analisar os resultados do mês anterior e definir as metas de cada cliente.\n  * 1-on-1 com o Diretor Operacional: Apresentação de churn, inadimplência e plano de ação.\n  * Agendamento das reuniões de alinhamento de resultado com os clientes-chave.\n- SEMANA 2:\n  * Verificação de reuniões agendadas pelo Especialista.\n  * Condução das reuniões de alinhamento de ROI com os clientes parceiros.\n  * 1-on-1 de alinhamento com os membros da equipe.\n- SEMANA 3:\n  * Cobrança ostensiva do preenchimento da planilha de resultados de vendas dos clientes.\n  * 1-on-1 com o Diretor Operacional para feedback parcial do mês.\n- SEMANAS 4 E 5:\n  * Análise de clientes em risco de cancelamento e reuniões de retenção.\n  * Atuação conjunta com o Financeiro na recuperação de eventuais inadimplentes.\n  * Avaliação de desempenho mensal e cálculo das comissões do time do Squad."
        },
        "node_head_rcf": {
          "id": "node_head_rcf",
          "parentId": "node_cargo_head",
          "text": "Head: RCF (KPIs de Churn & Retenção)",
          "color": "#a78bfa",
          "badge": "KPIS DE SQUAD",
          "shape": "card",
          "side": "right",
          "order": 3,
          "isCollapsed": false,
          "note": "RCF E MÉTRICAS DO HEAD DE OPERAÇÕES:\n- Taxa de Churn Mensal do Squad: Rigorosamente abaixo de 3% ao mês.\n- NPS Médio do Squad: Superior a 85 pontos nas pesquisas de satisfação trimestrais.\n- Cumprimento de SLAs de Entrega: Mais de 95% das tarefas do Monday entregues dentro do prazo estipulado.\n- Retenção Contratual Média (LTV): Média de permanência superior a 8 a 10 meses por cliente."
        },
        "node_cargo_cs": {
          "id": "node_cargo_cs",
          "parentId": "node_colaboradores",
          "text": "3.4 Customer Success (CS / Especialista)",
          "color": "#ec4899",
          "badge": "ENGAJAMENTO & CS",
          "shape": "card",
          "side": "right",
          "order": 3,
          "isCollapsed": false,
          "note": "CARGO 4: CUSTOMER SUCCESS (CS / ESPECIALISTA)\nO guardião do sucesso e engajamento do cliente no dia a dia. É o 'Head em treinamento' a todo momento, responsável por auditar o atendimento do cliente, garantir o preenchimento de métricas e manter o cliente ativo e satisfeito."
        },
        "node_cs_pdc": {
          "id": "node_cs_pdc",
          "parentId": "node_cargo_cs",
          "text": "CS: PDC (Padrão de Desempenho)",
          "color": "#f472b6",
          "badge": "MISSÃO & ENGAJAMENTO",
          "shape": "card",
          "side": "right",
          "order": 0,
          "isCollapsed": false,
          "note": "PDC DO ESPECIALISTA (CS):\n- Missão Primordial: Manter o cliente parceiro engajado, educado e ativo na metodologia da agência. Não precisa ser analítico como o Gestor de Tráfego, mas tem entendimento básico para interpretar o retorno financeiro do cliente.\n- Perfil: Extremamente comunicativo, empático, proativo, gosta de falar ao telefone e enviar áudios calorosos, resiliente e atento aos sinais sutis de insatisfação do cliente."
        },
        "node_cs_pti_diario": {
          "id": "node_cs_pti_diario",
          "parentId": "node_cargo_cs",
          "text": "CS: PTI (Rotina Diária de Seg a Sex)",
          "color": "#f472b6",
          "badge": "ROTINA DIÁRIA",
          "shape": "card",
          "side": "right",
          "order": 1,
          "isCollapsed": false,
          "note": "ROTINA DIÁRIA DO ESPECIALISTA (CS):\n- SEGUNDA-FEIRA:\n  * Bom dia nos grupos VIP e atualização das queixas pendentes.\n  * Participação na Weekly das 14h com o Squad.\n  * Programação das mensagens da semana e check-up de tarefas.\n- TERÇA-FEIRA:\n  * Agendamento de reuniões de alinhamento com clientes.\n  * Check-up do progresso e engajamento dos clientes nos grupos.\n  * Disparo de mensagens personalizadas para 20 clientes da carteira.\n- QUARTA-FEIRA:\n  * Condução de reuniões de acompanhamento e ligações telefônicas para clientes que estão com dados pendentes.\n- QUINTA-FEIRA:\n  * Envio de pesquisas rápidas de satisfação e conferência de contratos.\n  * Feedback 1-on-1 com o Head de Operações.\n- SEXTA-FEIRA:\n  * Reunião semanal de alinhamento do Chapter de Consultores/CS (14h).\n  * Planejamento da semana seguinte e mensagem de bom final de semana."
        },
        "node_cs_pti_mensal": {
          "id": "node_cs_pti_mensal",
          "parentId": "node_cargo_cs",
          "text": "CS: PTI (Ciclo Mensal em 4 Semanas)",
          "color": "#f472b6",
          "badge": "CICLO MENSAL",
          "shape": "card",
          "side": "right",
          "order": 2,
          "isCollapsed": false,
          "note": "CICLO MENSAL DAS 4 SEMANAS DO CS:\n- SEMANA 1:\n  * Envio do Checklist Mensal de implementação para os clientes.\n  * Envio do resumo em PDF da estratégia do mês.\n  * Ligações para os clientes que faltaram na última reunião para repasse do plano.\n- SEMANA 2:\n  * Acompanhamento da implementação prática do plano do mês.\n  * Envio de áudios de cobrança amigável para quem não participou ou não executou.\n  * Cobrança do preenchimento da planilha de resultados de vendas.\n- SEMANA 3:\n  * Ligações de follow-up via WhatsApp/Telefone para destravar o cliente.\n  * Solicitação de prints das conversas do WhatsApp do cliente para auditoria de script comercial.\n- SEMANAS 4 E 5:\n  * Finalização do checklist mensal e consolidação dos números.\n  * Agendamento da próxima reunião mensal de feedback com o Head.\n  * Coleta de depoimentos em vídeo e prova social de resultados expressivos."
        },
        "node_cs_auditoria": {
          "id": "node_cs_auditoria",
          "parentId": "node_cargo_cs",
          "text": "CS: Auditoria do Atendimento Comercial",
          "color": "#f472b6",
          "badge": "AUDITORIA COMERCIAL",
          "shape": "card",
          "side": "right",
          "order": 3,
          "isCollapsed": false,
          "note": "AUDITORIA PRÁTICA DO ATENDIMENTO DO CLIENTE:\nO CS atua como consultor de vendas do parceiro:\n1. Coleta de Prints Reais: Solicita toda semana 5 prints de atendimentos reais do WhatsApp da equipe do cliente.\n2. Análise dos 3 Pontos Críticos:\n   - Tempo de Resposta: O atendente respondeu em menos de 5 minutos ou demorou horas?\n   - Humanização: Usou áudio e empatia ou disparou texto automático frio e gigante?\n   - Condução e Chamada para Ação: Fez perguntas abertas para qualificar ou apenas passou o preço e sumiu?\n3. Devolutiva Construtiva: Envio de orientações pontuais com o script ideal a ser utilizado pelo atendente do cliente."
        },
        "node_cs_rcf": {
          "id": "node_cs_rcf",
          "parentId": "node_cargo_cs",
          "text": "CS: RCF (KPIs de Engajamento & NPS)",
          "color": "#f472b6",
          "badge": "KPIS DE CS",
          "shape": "card",
          "side": "right",
          "order": 4,
          "isCollapsed": false,
          "note": "RCF E MÉTRICAS DO ESPECIALISTA (CS):\n- Taxa de Resposta dos Clientes: Superior a 90% dos clientes ativos interagindo semanalmente no grupo VIP.\n- Preenchimento da Planilha de Vendas: 100% das planilhas de vendas preenchidas até o 3º dia útil do mês subsequente.\n- NPS Individual: Score de satisfação acima de 9.0 em sua carteira do Squad.\n- Identificação Antecipada de Churn: 100% dos clientes com queda de engajamento sinalizados ao Head com no mínimo 15 dias de antecedência."
        },
        "node_cargo_estrategista": {
          "id": "node_cargo_estrategista",
          "parentId": "node_colaboradores",
          "text": "3.5 Estrategista (Inteligência & Engenharia de Vendas)",
          "color": "#6366f1",
          "badge": "PAC & OFERTAS",
          "shape": "card",
          "side": "right",
          "order": 4,
          "isCollapsed": false,
          "note": "CARGO 5: ESTRATEGISTA\nCérebro do Plano de Aceleração Comercial (PAC). Responsável por desenhar a estratégia de posicionamento, esteira de criativos, ofertas irresistíveis e alinhamento do funil de conversão para o nicho de mercado."
        },
        "node_est_pdc": {
          "id": "node_est_pdc",
          "parentId": "node_cargo_estrategista",
          "text": "Estrategista: PDC (Padrão de Desempenho)",
          "color": "#818cf8",
          "badge": "MISSÃO & VISÃO",
          "shape": "card",
          "side": "right",
          "order": 0,
          "isCollapsed": false,
          "note": "PDC DO ESTRATEGISTA:\n- Missão Primordial: Traduzir os objetivos de faturamento do cliente em um plano tático acionável (PAC), definindo a esteira de produtos, os ângulos emocionais dos criativos e os gatilhos persuasivos do funil.\n- Perfil: Pensamento analítico apurado, profundo conhecimento do comportamento do consumidor e gatilhos mentais de vendas, domínio de copywriting e habilidade de sintetizar conceitos complexos em planos simples."
        },
        "node_est_pti_onboarding": {
          "id": "node_est_pti_onboarding",
          "parentId": "node_cargo_estrategista",
          "text": "Estrategista: PTI (Diagnóstico & Desenho do PAC)",
          "color": "#818cf8",
          "badge": "PLANO TÁTICO",
          "shape": "card",
          "side": "right",
          "order": 1,
          "isCollapsed": false,
          "note": "PTI DE IMERSÃO E DESENHO ESTRATÉGICO:\n- DIAGNÓSTICO NOS PRIMEIROS 2 DIAS:\n  * Análise aprofundada das respostas do formulário de onboarding do cliente.\n  * Espionagem de concorrentes no nicho (Biblioteca de Anúncios da Meta, palavras-chave no Google, comunicação orgânica).\n- DESENHO DO PLANO DE ACELERAÇÃO COMERCIAL (PAC):\n  * Definição da Proposta Única de Valor (PUV).\n  * Estruturação de Ofertas Irresistíveis (Front-End com margem atrativa e Back-End de alto LTV).\n  * Definição dos canais prioritários de atração (Meta Ads para demanda reprimida ou Google Ads para busca imediata).\n  * Elaboração do cronograma de testes de criativos para os primeiros 30 dias."
        },
        "node_est_pti_roteiros": {
          "id": "node_est_pti_roteiros",
          "parentId": "node_cargo_estrategista",
          "text": "Estrategista: Roteirização ISI & Esteira de Ofertas",
          "color": "#818cf8",
          "badge": "COPYWRITING",
          "shape": "card",
          "side": "right",
          "order": 2,
          "isCollapsed": false,
          "note": "METODOLOGIA DE ROTEIRIZAÇÃO ISI:\nO Estrategista produz briefs de alta conversão para o Designer e GT:\n- I (Interrupção - Primeiros 3 segundos):\n  * Gancho visual e verbal que quebra o padrão de rolagem do feed (ex: 'Se você mora em [Cidade] e sofre com [Dor Específica], pare tudo e veja este vídeo!').\n- S (Solução - 15 a 45 segundos):\n  * Apresentação clara de como o método/serviço do cliente elimina a dor sem complexidade e com autoridade médica/profissional.\n- I (Invocação - Últimos 10 segundos):\n  * Chamada para ação (CTA) cirúrgica: 'Toque no botão 'Saiba Mais' abaixo e receba nossa condição especial direto no WhatsApp'."
        },
        "node_est_rcf": {
          "id": "node_est_rcf",
          "parentId": "node_cargo_estrategista",
          "text": "Estrategista: RCF (KPIs de Eficiência & ROI)",
          "color": "#818cf8",
          "badge": "KPIS DE ESTRATÉGIA",
          "shape": "card",
          "side": "right",
          "order": 3,
          "isCollapsed": false,
          "note": "RCF E MÉTRICAS DO ESTRATEGISTA:\n- Prazo de Entrega do PAC: Plano de Aceleração Comercial pronto e aprovado pelo cliente em até 72 horas úteis após o Kick-off.\n- Taxa de Sucesso dos Ângulos Testados: Pelo menos 2 em cada 5 novos ângulos de criativos validados como vencedores de vendas.\n- ROI Global das Operações Aceleradas: Proporcionar retorno financeiro direto de pelo menos 3x a 5x sobre o investimento global do cliente."
        },
        "node_cargo_gt": {
          "id": "node_cargo_gt",
          "parentId": "node_colaboradores",
          "text": "3.6 Gestor de Tráfego (Mídia Paga & Comunicação Pivô)",
          "color": "#3b82f6",
          "badge": "TRÁFEGO & PIVÔ",
          "shape": "card",
          "side": "right",
          "order": 5,
          "isCollapsed": false,
          "note": "CARGO 6: GESTOR DE TRÁFEGO (GT)\nEspecialista em compra de mídia e gestão de anúncios no Meta Ads e Google Ads. Além da gestão técnica de campanhas, é a peça-chave da 'comunicação pivô' nos grupos de WhatsApp enquanto o Head e o Especialista estão em reuniões."
        },
        "node_gt_pdc": {
          "id": "node_gt_pdc",
          "parentId": "node_cargo_gt",
          "text": "GT: PDC (Padrão de Desempenho)",
          "color": "#60a5fa",
          "badge": "MISSÃO & TÉCNICA",
          "shape": "card",
          "side": "right",
          "order": 0,
          "isCollapsed": false,
          "note": "PDC DO GESTOR DE TRÁFEGO:\n- Missão Primordial: Operar o Gerenciador de Anúncios com excelência técnica, garantir que as contas nunca fiquem sem saldo ou pausadas, otimizar custos por lead e garantir resposta ágil no grupo VIP (comunicação pivô).\n- Perfil: Extremamente analítico, disciplinado, atento a métricas diárias, orientado a dados reais de faturamento (e não apenas CPC/CTR) e pesquisador incansável de novos criativos validados."
        },
        "node_gt_pti_diario": {
          "id": "node_gt_pti_diario",
          "parentId": "node_cargo_gt",
          "text": "GT: PTI (Rotina Diária de Seg a Sex)",
          "color": "#60a5fa",
          "badge": "ROTINA DIÁRIA",
          "shape": "card",
          "side": "right",
          "order": 1,
          "isCollapsed": false,
          "note": "ROTINA DIÁRIA DO GESTOR DE TRÁFEGO:\n- SEGUNDA-FEIRA:\n  * 08h30: Atualização do Saldo Diário de todas as contas no Monday.com.\n  * 09h30: Conferência geral de todos os grupos VIP de WhatsApp.\n  * 10h30: Envio do Relatório Semanal para os clientes (Script do Notion).\n  * 11h30: Atualização das Queixas de Clientes no Monday (Queixa + Solução).\n  * 14h00: Participação na Reunião Semanal do Squad (Weekly).\n  * 15h30: Planejamento das subidas e testes da semana.\n- TERÇA-FEIRA:\n  * Saldo Diário no Monday.\n  * Conferência geral dos grupos VIP.\n  * Otimizações de Campanhas no Meta Ads/Google Ads (conforme processo no Monday).\n  * Solicitação de novos criativos e briefings para o Designer.\n- QUARTA-FEIRA:\n  * Saldo Diário no Monday.\n  * Conferência do preenchimento da planilha de vendas do cliente + Feedback de congratulação no grupo.\n  * Otimizações técnicas de campanhas.\n  * Solicitação de novos criativos.\n- QUINTA-FEIRA:\n  * Saldo Diário no Monday.\n  * Otimizações e subida de novas campanhas.\n  * Reunião Semanal dos Gestores de Tráfego (Chapter de GTs para troca de hacks e benchmarks).\n  * Feedback 1-on-1 com o Head de Operações.\n- SEXTA-FEIRA:\n  * Saldo Diário no Monday (blindagem de saldos para o final de semana).\n  * Planejamento da próxima semana.\n  * Mensagem de bom final de semana a todos os clientes parceiros."
        },
        "node_gt_otimizacao": {
          "id": "node_gt_otimizacao",
          "parentId": "node_cargo_gt",
          "text": "GT: Metodologia Tráfego 7D & Matança de Criativos",
          "color": "#60a5fa",
          "badge": "MÍDIA 7D",
          "shape": "card",
          "side": "right",
          "order": 2,
          "isCollapsed": false,
          "note": "METODOLOGIA OPERACIONAL DO TRÁFEGO 7D:\n1. Teste Científico Isolado: Cada novo anúncio é testado isoladamente com orçamento controlado por 72h a 96h.\n2. Matança Implacável de Anúncios Ruins: Conjuntos com Custo por Lead (CPL) 40% acima do teto estipulado são pausados sem apego emocional.\n3. Escala Dupla:\n   - Escala Vertical: Aumento de 15% a 20% no orçamento a cada 48h em conjuntos consistentes.\n   - Escala Horizontal: Duplicação de criativos vencedores para novos públicos de interesse, semelhantes (Lookalike) e públicos abertos com segmentação via criativo.\n4. Remarketing Omnipresente: Campanhas perenes de remarketing para quem interagiu no Instagram ou visualizou 50%+ dos vídeos nos últimos 30 dias."
        },
        "node_gt_rcf": {
          "id": "node_gt_rcf",
          "parentId": "node_cargo_gt",
          "text": "GT: RCF (KPIs de Mídia & Comunicação Pivô)",
          "color": "#60a5fa",
          "badge": "KPIS DE TRÁFEGO",
          "shape": "card",
          "side": "right",
          "order": 3,
          "isCollapsed": false,
          "note": "RCF E MÉTRICAS DO GESTOR DE TRÁFEGO:\n- Zero Contas Pausadas por Saldo: 100% das contas com saldo positivo e monitoramento preventivo.\n- Custo por Lead (CPL) na Meta: Manutenção do CPL dentro da faixa orçada pelo Estrategista.\n- SLA de Comunicação Pivô: Resposta nos grupos VIP em menos de 15 minutos durante o horário de reuniões do Head/CS.\n- Volume de Novos Criativos Validados: Mínimo de 4 novos criativos vencedores validados por mês para cada cliente (comissionamento específico por criativo validado)."
        },
        "node_cargo_suporte": {
          "id": "node_cargo_suporte",
          "parentId": "node_colaboradores",
          "text": "3.7 Suporte (Infraestrutura, Acessos & Técnico)",
          "color": "#14b8a6",
          "badge": "INFRAESTRUTURA",
          "shape": "card",
          "side": "right",
          "order": 6,
          "isCollapsed": false,
          "note": "CARGO 7: SUPORTE\nBraço técnico e operacional de infraestrutura. Resolve entraves de acessos a contas, verificação de domínios, instalação de tags de rastreamento, apelações de bloqueios na Meta e integrações de CRM e webhooks."
        },
        "node_sup_pdc": {
          "id": "node_sup_pdc",
          "parentId": "node_cargo_suporte",
          "text": "Suporte: PDC (Padrão de Desempenho)",
          "color": "#2dd4bf",
          "badge": "MISSÃO & AGILIDADE",
          "shape": "card",
          "side": "right",
          "order": 0,
          "isCollapsed": false,
          "note": "PDC DO SUPORTE TÉCNICO:\n- Missão Primordial: Garantir que nenhuma campanha ou processo fique parado por entrave técnico, falta de acesso ou erro de integração, mantendo o tempo de resposta em menos de 15 minutos e resolução em menos de 2 horas.\n- Perfil: Ágil, curioso tecnologicamente, focado em resolver problemas sem burocracia, especialista em troubleshooting de gerenciadores da Meta e integrações de API."
        },
        "node_sup_pti_rotina": {
          "id": "node_sup_pti_rotina",
          "parentId": "node_cargo_suporte",
          "text": "Suporte: PTI (Setup de Ativos & Desbloqueios)",
          "color": "#2dd4bf",
          "badge": "CHECKLIST TÉCNICO",
          "shape": "card",
          "side": "right",
          "order": 1,
          "isCollapsed": false,
          "note": "PTI E CHECKLISTS TÉCNICOS DO SUPORTE:\n- ONBOARDING TÉCNICO (DIA 1):\n  * Envio de links de parceiro e aprovação de acesso às Business Managers (BM) da Meta e Contas Google.\n  * Verificação de domínio e configuração dos Eventos Agregados.\n  * Validação de Pixel e API de Conversões via Google Tag Manager (GTM).\n- GESTÃO DE CONTINGÊNCIA E DESBLOQUEIOS:\n  * Abertura imediata de chamados no suporte Concierge da Meta em caso de restrições de conta.\n  * Envio de documentação de apelação e ativação de contas de anúncio reservas (BM contingente).\n- SUPORTE A INTEGRAÇÕES E WEBHOOKS:\n  * Integração de formulários de leads com o CRM Kommo/Uai Dash via Webhooks (Make/Zapier)."
        },
        "node_sup_rcf": {
          "id": "node_sup_rcf",
          "parentId": "node_cargo_suporte",
          "text": "Suporte: RCF (SLAs Técnicos & Disponibilidade)",
          "color": "#2dd4bf",
          "badge": "KPIS DE SUPORTE",
          "shape": "card",
          "side": "right",
          "order": 2,
          "isCollapsed": false,
          "note": "RCF E MÉTRICAS DO SUPORTE TÉCNICO:\n- Tempo de Primeira Resposta: Menos de 15 minutos em todos os chamados técnicos abertos pelo time ou clientes.\n- SLA de Resolução de Acessos: 100% dos acessos de novos clientes configurados e homologados em até 24 horas úteis.\n- Taxa de Resolução no Primeiro Contato (FCR): Acima de 85% dos problemas técnicos resolvidos sem necessidade de reabertura.\n- Uptime de Rastreamento: Zero perda de dados de conversão por erro de configuração de tags ou pixel."
        }
      }
    }
  },
];